import { INSPECTION_TYPE_ENUM, AL_VEHICLE_TYPE_ENUM, INTERNAL_USE_TYPE_ENUM, AL_USE_TYPE_ENUM, INTERNAL_FUEL_TYPE_ENUM, AL_FUEL_TYPE_ENUM, ID_DOCUMENT_TYPE_ENUM, VehicleCoverageCodes, VehicleCoverageFriendlyNames, insuranceMinimumLevelTypesEnum, INSURANCE_DOCUMENT_TYPE_ENUM, STATE_DATA_TAR_PROCESS_KEYS, MIN_FIELDS_TO_COLLECT, AK_VEHICLE_TYPE_ENUM, AZ_FUEL_TYPE_ENUM, AZ_VEHICLE_TYPE_ENUM, AR_FUEL_TYPE_ENUM, AR_VEHICLE_TYPE_ENUM, INTERNAL_CYLINDER_TYPE_ENUM, AR_CYLINDER_TYPE_ENUM, CA_FUEL_TYPE_ENUM, CA_VEHICLE_TYPE_ENUM, TAX_CONSTS, CO_USE_TYPE_ENUM, CO_FUEL_TYPE_ENUM, CO_VEHICLE_TYPE_ENUM, INTERNAL_BODY_TYPE_ENUM, CO_BODY_TYPE_ENUM, CO_BODY_TYPE_ID_ENUM, INTERNAL_COLOR_ENUM, CO_COLOR_ENUM, CT_FUEL_TYPE_ENUM, CT_VEHICLE_TYPE_ENUM, CT_USE_TYPE_ENUM, DC_FUEL_TYPE_ENUM, DC_VEHICLE_TYPE_ENUM, DC_USE_TYPE_ENUM, DE_FUEL_TYPE_ENUM, DE_VEHICLE_TYPE_ENUM, FL_FUEL_TYPE_ENUM, FL_VEHICLE_TYPE_ENUM, FL_COLOR_ENUM, FL_TITLE_TYPE_ENUM, GA_USE_TYPE_ENUM, GA_FUEL_TYPE_ENUM, GA_VEHICLE_TYPE_ENUM, GA_CYLINDER_TYPE_ENUM, GA_COLOR_ENUM, ID_VEHICLE_TYPE_ENUM, DEFAULT_FUEL_TYPE_ENUM, ID_USE_TYPE_ENUM, ID_COLOR_ENUM, IL_BODY_TYPE_ID_ENUM, IL_VEHICLE_TYPE_ENUM, IL_FUEL_TYPE_ENUM, IL_COLOR_ENUM, IN_VEHICLE_TYPE_ENUM, IN_FUEL_TYPE_ENUM, IA_VEHICLE_TYPE_ENUM, IA_USE_TYPE_ENUM, IA_FUEL_TYPE_ENUM, KS_VEHICLE_TYPE_ENUM, KS_FUEL_TYPE_ENUM, KS_COLOR_ENUM, KY_USE_TYPE_ENUM, KY_FUEL_TYPE_ENUM, KY_VEHICLE_TYPE_ENUM, LA_USE_TYPE_ENUM, LA_VEHICLE_TYPE_ENUM, LA_COLOR_ENUM, ME_PLATE_TYPE_ENUM, ME_FUEL_TYPE_ENUM, ME_VEHICLE_TYPE_ENUM, ME_USE_TYPE_ENUM, ME_COLOR_ENUM, MD_USE_TYPE_ENUM, MA_USE_TYPE_ENUM, MD_FUEL_TYPE_ENUM, MD_VEHICLE_TYPE_ENUM, NY_BODY_TYPE_ENUM, MA_VEHICLE_TYPE_ENUM, MA_COLOR_ENUM, MA_FUEL_TYPE_ENUM, INTERNAL_ID_TYPE_ENUM, INTERNAL_DOORS_ENUM, MA_DOORS_ENUM, INTERNAL_TRANSMISSION_ENUM, MI_PLATE_TYPE_ENUM, MI_USE_TYPE_ENUM, MI_FUEL_TYPE_ENUM, MI_VEHICLE_TYPE_ENUM, MI_BODY_TYPE_ENUM, MI_BODY_TYPE_ID_ENUM, MN_FUEL_TYPE_ENUM, MN_VEHICLE_TYPE_ENUM, MN_USE_TYPE_ENUM, MN_COLOR_ENUM, MS_PLATE_TYPE_ENUM, MS_FUEL_TYPE_ENUM, MS_VEHICLE_TYPE_ENUM, MO_REG_PERIOD_TYPE_ENUM, MO_FUEL_TYPE_ENUM, MO_VEHICLE_TYPE_ENUM, MO_COLOR_ENUM, INTERNAL_NUMBER_WHEELS_ENUM, MO_NUMBER_WHEELS_ENUM, MT_REG_PERIOD_TYPE_ENUM, MT_USE_TYPE_ENUM, MT_FUEL_TYPE_ENUM, MT_VEHICLE_TYPE_ENUM, MT_BODY_TYPE_ENUM, MT_BODY_TYPE_ID_ENUM, MT_COLOR_ENUM, NE_USE_TYPE_ENUM, NE_FUEL_TYPE_ENUM, NE_VEHICLE_TYPE_ENUM, NV_REG_PERIOD_TYPE_ENUM, NV_PLATE_TYPE_ENUM, NV_USE_TYPE_ENUM, NV_FUEL_TYPE_ENUM, NV_VEHICLE_TYPE_ENUM, NH_FUEL_TYPE_ENUM, NH_VEHICLE_TYPE_ENUM, NJ_REG_PERIOD_TYPE_ENUM, NJ_USE_TYPE_ENUM, NJ_FUEL_TYPE_ENUM, NJ_VEHICLE_TYPE_ENUM, NJ_BODY_TYPE_ENUM, NJ_BODY_TYPE_ID_ENUM, NY_BODY_TYPE_ID_ENUM, NM_REG_PERIOD_TYPE_ENUM, NM_PLATE_TYPE_ENUM, NM_USE_TYPE_ENUM, NM_FUEL_TYPE_ENUM, NM_VEHICLE_TYPE_ENUM, NM_COLOR_ENUM, NY_USE_TYPE_ENUM, NY_FUEL_TYPE_ENUM, NY_VEHICLE_TYPE_ENUM, NY_COLOR_ENUM, NC_PLATE_TYPE_ENUM, NC_USE_TYPE_ENUM, NC_VEHICLE_TYPE_ENUM, ND_FUEL_TYPE_ENUM, ND_VEHICLE_TYPE_ENUM, ND_COLOR_ENUM, OH_FUEL_TYPE_ENUM, OH_VEHICLE_TYPE_ENUM, OH_COLOR_ENUM, OK_FUEL_TYPE_ENUM, OK_VEHICLE_TYPE_ENUM, OK_COLOR_ENUM, OK_USE_TYPE_ENUM, OR_REG_PERIOD_TYPE_ENUM, OR_VEHICLE_TYPE_ENUM, OR_USE_TYPE_ENUM, OR_BODY_TYPE_ID_ENUM, OR_FUEL_TYPE_ENUM, PA_FUEL_TYPE_ENUM, PA_VEHICLE_TYPE_ENUM, PA_USE_TYPE_ENUM, PA_BODY_TYPE_ID_ENUM, PA_REG_PERIOD_TYPE_ENUM, RI_FUEL_TYPE_ENUM, RI_VEHICLE_TYPE_ENUM, RI_USE_TYPE_ENUM, SC_VEHICLE_TYPE_ENUM, SC_USE_TYPE_ENUM, SD_NUMBER_OF_WHEELS_ENUM, SD_USE_TYPE_ENUM, SD_FUEL_TYPE_ENUM, SD_VEHICLE_TYPE_ENUM, TN_USE_TYPE_ENUM, TN_VEHICLE_TYPE_ENUM, TN_COLOR_ENUM, TX_FUEL_TYPE_ENUM, TX_VEHICLE_TYPE_ENUM, TX_BODY_TYPE_ID_ENUM, TX_USE_TYPE_ENUM, TX_COLOR_ENUM, UT_PLATE_TYPE_ENUM, UT_REG_PERIOD_TYPE_ENUM, UT_USE_TYPE_ENUM, UT_FUEL_TYPE_ENUM, UT_VEHICLE_TYPE_ENUM, VT_REG_PERIOD_TYPE_ENUM, VT_USE_TYPE_ENUM, VT_FUEL_TYPE_ENUM, VT_VEHICLE_TYPE_ENUM, VA_USE_TYPE_ENUM, VA_FUEL_TYPE_ENUM, VA_VEHICLE_TYPE_ENUM, VA_BODY_TYPE_ENUM, VA_BODY_TYPE_ID_ENUM, VA_REG_PERIOD_TYPE_ENUM, REQUESTED_TITLE_TYPE_ENUM, WA_USE_TYPE_ENUM, WA_FUEL_TYPE_ENUM, WA_VEHICLE_TYPE_ENUM, WA_COLOR_ENUM, WA_FILING_TYPE_ENUM, WA_REG_SERVICE_TYPE_ENUM, WV_USE_TYPE_ENUM, WV_FUEL_TYPE_ENUM, WV_VEHICLE_TYPE_ENUM, WI_FUEL_TYPE_ENUM, WI_VEHICLE_TYPE_ENUM, WI_COLOR_ENUM, WI_USE_TYPE_ENUM, WY_FUEL_TYPE_ENUM, WY_VEHICLE_TYPE_ENUM, WY_USE_TYPE_ENUM } from '../../constants.js';
import '../../types/ActionItem.js';
import '../../types/Address.js';
import '../../types/admin_portal/conversations/api/ConversationStatsResponse.js';
import '../../types/admin_portal/conversations/api/GetConversationMessagesResponse.js';
import '../../types/admin_portal/discounts/DiscountCombination.js';
import '../../types/admin_portal/discounts/DiscountMethod.js';
import '../../types/admin_portal/discounts/DiscountStatus.js';
import '../../types/admin_portal/discounts/DiscountType.js';
import '../../types/admin_portal/leads/table/LeadsServiceSort.js';
import '../../types/admin_portal/leads/table/LeadsTableTab.js';
import '../../types/admin_portal/orders/views/OrderDocuments.js';
import '../../types/admin_portal/orders/table/OrderPaymentChoice.js';
import '../../types/admin_portal/orders/table/OrdersServiceSort.js';
import '../../types/admin_portal/orders/table/OrdersTableTab.js';
import '../../types/admin_portal/orders/validation/vinValidation.js';
import '../../types/admin_portal/orders/validation/odometerValidation.js';
import '../../types/admin_portal/orders/validation/engineNumberValidation.js';
import '../../types/admin_portal/orders/validation/inventoryValidation.js';
import '../../types/admin_portal/orders/validation/tempTagValidation.js';
import '../../types/admin_portal/orders/validation/assemblyValidation.js';
import '../../types/admin_portal/orders/validation/inspectionValidation.js';
import '../../types/admin_portal/orders/validation/transitValidation.js';
import '../../types/admin_portal/orders/validation/fileUploadValidation.js';
import '../../types/admin_portal/orders/validation/noteValidation.js';
import '../../types/admin_portal/orders/validation/warrantyValidation.js';
import '../../types/admin_portal/orders/validation/fulfillmentValidation.js';
import '../../types/admin_portal/orders/validation/accessoriesValidation.js';
import '../../types/admin_portal/orders/validation/productionValidation.js';
import '../../types/admin_portal/team/validation/teamSearchDto.js';
import '../../types/admin_portal/team/validation/teamCreateMembersDto.js';
import '../../types/AlgoliaSearchRecord.js';
import '../../types/Auth.js';
import '../../types/auto_debit/Charge.js';
import '../../types/notifications/NotificationEvent.js';
import '../../types/notifications/NotificationSubscription.js';
import '../../types/notifications/NotificationTemplate.js';
import '../../types/BrexTransfer.js';
import '../../types/Buyer.js';
import '../../types/CheckoutCart.js';
import '../../types/CheckoutDisclosures.js';
import '../../types/conversations/Conversation.js';
import '../../types/conversations/ConversationStats.js';
import '../../types/coverage/CoverageBundle.js';
import '../../types/coverage/CoverageProduct.js';
import '../../types/Credits.js';
import '../../types/CtaConfig.js';
import '../../types/dashboards/AdminPortalOrdersDashboard.js';
import '../../types/dashboards/RetailerPortalOrdersDashboard.js';
import '../../types/DiscountCampaign.js';
import '../../types/DiscountTypes.js';
import '../../types/imports/ImportJob.js';
import '../../types/leads/Lead.js';
import '../../types/IncomingCheckoutCart.js';
import '../../types/inventory/Assignment.js';
import '../../types/inventory/CosmeticReport.js';
import '../../types/inventory/InventoryItem.js';
import '../../types/inventory/LockRequest.js';
import '../../types/inventory/MechanicalReport.js';
import '../../types/invitations/Invitation.js';
import '../../types/LegacyIncomingCheckoutCart.js';
import '../../types/lender/events.js';
import '../../types/lender/general.js';
import '../../types/lender/generic.js';
import '../../types/lender/Lender.js';
import '../../types/Listing.js';
import '../../types/Logos.js';
import '../../types/Membership.js';
import '../../types/Oem.js';
import '../../types/OrderExternalStatus.js';
import '../../types/OverflowFees.js';
import '../../types/Payable.js';
import '../../types/PaymentConfig.js';
import '../../types/Payout.js';
import '../../types/PdfFieldTag.js';
import '../../types/PlacedOrder.js';
import '../../types/preorders/Preorder.js';
import '../../types/preorders/PreorderPaymentConfig.js';
import '../../types/PricingModelDetails.js';
import '../../types/PropertyAggregation.js';
import '../../types/pubsub/EventCodes.js';
import '../../types/pubsub/Topics.js';
import 'bad-words';
import 'moment';
import 'ua-parser-js';
import 'yup';
import { StateAbbreviation, StateName } from '../../types/StateAbbreviation.js';
import '../../utils/createLog.js';
import '../../types/servicesProviders/services/Services.js';
import '../../types/servicesProviders/services/ServicesProviderAssemblyData.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageFulfillmentData.js';
import '../../types/servicesProviders/services/ServicesProviderCoveragePlatformData.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageTaxData.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageVendorData.js';
import '../../types/servicesProviders/services/ServicesProviderDeliveryData.js';
import '../../types/servicesProviders/services/ServicesProviderDomainsData.js';
import '../../types/servicesProviders/services/ServicesProviderExternalFeesData.js';
import '../../types/servicesProviders/services/ServicesProviderExternalTaxData.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingBrokerageData.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingBrokeragePlatformData.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingData.js';
import '../../types/servicesProviders/services/ServicesProviderFreightData.js';
import '../../types/servicesProviders/services/ServicesProviderInspectionData.js';
import '../../types/servicesProviders/services/ServicesProviderInternalFeesData.js';
import '../../types/servicesProviders/services/ServicesProviderInventoryData.js';
import '../../types/servicesProviders/services/ServicesProviderLicensureData.js';
import '../../types/servicesProviders/services/ServicesProviderOriginatorData.js';
import '../../types/servicesProviders/services/ServicesProviderPayableData.js';
import '../../types/servicesProviders/services/ServicesProviderPickupData.js';
import '../../types/servicesProviders/services/ServicesProviderPlatformData.js';
import '../../types/servicesProviders/services/ServicesProviderProcessingFeesData.js';
import '../../types/servicesProviders/services/ServicesProviderProgramOwnerData.js';
import '../../types/servicesProviders/services/ServicesProviderRegistrationData.js';
import '../../types/servicesProviders/services/ServicesProviderSaleData.js';
import '../../types/servicesProviders/services/ServicesProviderTariffData.js';
import '../../types/servicesProviders/services/ServicesProviderTempTagData.js';
import '../../types/servicesProviders/services/ServicesProviderTitlingData.js';
import '../../types/servicesProviders/services/ServicesProviderAssembly.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageFulfillment.js';
import '../../types/servicesProviders/services/ServicesProviderCoveragePlatform.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageTax.js';
import '../../types/servicesProviders/services/ServicesProviderCoverageVendor.js';
import '../../types/servicesProviders/services/ServicesProviderDelivery.js';
import '../../types/servicesProviders/services/ServicesProviderDomains.js';
import '../../types/servicesProviders/services/ServicesProviderExternalFees.js';
import '../../types/servicesProviders/services/ServicesProviderExternalTax.js';
import '../../types/servicesProviders/services/ServicesProviderFinancing.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingBrokerage.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingBrokeragePlatform.js';
import '../../types/servicesProviders/services/ServicesProviderFinancingBrokerageSubvention.js';
import '../../types/servicesProviders/services/ServicesProviderFreight.js';
import '../../types/servicesProviders/services/ServicesProviderInspection.js';
import '../../types/servicesProviders/services/ServicesProviderInternalFees.js';
import '../../types/servicesProviders/services/ServicesProviderInventory.js';
import '../../types/servicesProviders/services/ServicesProviderLicensure.js';
import '../../types/servicesProviders/services/ServicesProviderOriginator.js';
import '../../types/servicesProviders/services/ServicesProviderPayable.js';
import '../../types/servicesProviders/services/ServicesProviderPickup.js';
import '../../types/servicesProviders/services/ServicesProviderPlatform.js';
import '../../types/servicesProviders/services/ServicesProviderProcessingFees.js';
import '../../types/servicesProviders/services/ServicesProviderProgramOwner.js';
import '../../types/servicesProviders/services/ServicesProviderRegistration.js';
import '../../types/servicesProviders/services/ServicesProviderSale.js';
import '../../types/servicesProviders/services/ServicesProviderTariff.js';
import '../../types/servicesProviders/services/ServicesProviderTempTag.js';
import '../../types/servicesProviders/services/ServicesProviderTitling.js';
import '../../types/ReEngagementConfig.js';
import '../../types/Repository.js';
import '../../types/Sardine.js';
import '../../types/Scraping.js';
import '../../types/servicesProviders/configurations/AiBdcSettings.js';
import '../../types/servicesProviders/configurations/AssemblyServiceConfig.js';
import '../../types/servicesProviders/configurations/BdcServiceConfig.js';
import '../../types/servicesProviders/configurations/CoverageFulfillmentServiceConfig.js';
import '../../types/servicesProviders/configurations/CoveragePlatformServiceConfig.js';
import '../../types/servicesProviders/configurations/CoverageTaxServiceConfig.js';
import '../../types/servicesProviders/configurations/CoverageVendorServiceConfig.js';
import '../../types/servicesProviders/configurations/DeliveryServiceConfig.js';
import '../../types/servicesProviders/configurations/DomainsServiceConfig.js';
import '../../types/servicesProviders/configurations/SharedServiceConfig.js';
import '../../types/servicesProviders/configurations/FinancingBrokeragePlatformServiceConfig.js';
import '../../types/servicesProviders/configurations/FinancingBrokerageServiceConfig.js';
import '../../types/servicesProviders/configurations/FinancingServiceConfig.js';
import '../../types/servicesProviders/configurations/FreightServiceConfig.js';
import '../../types/servicesProviders/configurations/InspectionServiceConfig.js';
import '../../types/servicesProviders/configurations/InventoryServiceConfig.js';
import '../../types/servicesProviders/configurations/LicensureServiceConfig.js';
import '../../types/servicesProviders/configurations/PickupServiceConfig.js';
import '../../types/servicesProviders/configurations/PlatformServiceConfig.js';
import '../../types/servicesProviders/configurations/ProgramOwnerServiceConfig.js';
import '../../types/servicesProviders/configurations/SaleServiceConfig.js';
import '../../types/servicesProviders/configurations/TempTagServiceConfig.js';
import '../../types/servicesProviders/constants/OnboardingCode.js';
import '../../types/servicesProviders/constants/ProductConfigurationOptions.js';
import '../../types/servicesProviders/serviceAccess/OnboardingCodeToServiceAccess.js';
import '../../types/servicesProviders/serviceAccess/serviceAccess.js';
import '../../types/servicesProviders/serviceAccess/ServiceAccessServicesTemplates.js';
import '../../types/servicesProviders/serviceAccess/ServiceAccessTemplateCode.js';
import '../../types/servicesProviders/serviceAccess/ServiceSections.js';
import '../../types/servicesProviders/ServicesProvider.js';
import '../../types/servicesProviders/ServicesProviderConfig.js';
import '../../types/servicesProviders/ServicesProviderData.js';
import '../../types/servicesProviders/ServicesProviderPricing.js';
import '../../types/SpecEnrichment.js';
import '../../types/SupportHours.js';
import '../../types/systems/ClientConfig.js';
import '../../types/systems/pcrs/Pcrs.js';
import '../../types/systems/SystemType.js';
import '../../types/UnitedPostalService.js';
import '../../types/Units.js';
import '../../types/User.js';
import '../../types/validation/Validation.js';
import '../../types/Validator.js';
import '../../types/VehicleSpecMetadata.js';
import { VehicleType } from '../../types/VehicleTypes.js';

const STATE_DATA = {
    [StateAbbreviation.AL]: {
        abbreviation: StateAbbreviation.AL,
        supportsRON: false,
        name: StateName.AL,
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 31.5,
            estimatedTitlingFees: 16.5,
        },
        taxes: {
            salesTaxPercentage: 0.02,
            variableFee: 15,
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.YES,
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    consts: {
                        odometerReadingIn: 'Miles',
                        remittingAdValoremForOwner: true,
                    },
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    manufacturesSuggestedRetailPrice: 'purchasedVehicle.basePrice',
                },
            },
            vituEnum: {
                vehicleType: {
                    [VehicleType.PASSENGER]: AL_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOPED]: AL_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOTORCYCLE]: AL_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.OHV]: AL_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ATV]: AL_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: AL_VEHICLE_TYPE_ENUM.UTV,
                    [VehicleType.LOW_SPEED]: AL_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: AL_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: AL_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: AL_FUEL_TYPE_ENUM.GASOLINE,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: AL_FUEL_TYPE_ENUM.ELECTRIC,
                },
            },
        },
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
        ],
        insurance: {
            optional: false,
            insuranceName: 'Alabama Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: null,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: true,
            mustBeInState: true,
            mustBeInStateForMilitary: true,
            miscellaneous: [],
            exemptVehicleTypes: [],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
            ],
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.MOPED,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ], // OHVs don't need to be titled in AL
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
    },
    [StateAbbreviation.AK]: {
        abbreviation: StateAbbreviation.AK,
        supportsRON: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 80,
            estimatedTitlingFees: 15,
        },
        taxes: {
            salesTaxPercentage: 0.0,
            variableFee: 12,
        },
        insurance: {
            optional: false,
            insuranceName: '',
            minFieldsToCollect: [],
            minDaysValid: 0,
            maxDaysUntilEffective: 0,
            proofRequired: false,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 100000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
            ],
        },
        titlingAndRegistration: {
            vituEnum: {
                // AK does not have a Fuel Type requirement
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: INTERNAL_FUEL_TYPE_ENUM.GASOLINE,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: INTERNAL_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: AK_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.PASSENGER]: AK_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOPED]: AK_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.DUAL_SPORT]: AK_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.ATV]: AK_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: AK_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: AK_VEHICLE_TYPE_ENUM.PASSENGER,
                },
            },
            stateReqs: {
                vehicle: {
                    consts: {
                        unladenWeightValidity: 'Actual',
                        numberOfRegYears: 0,
                    },
                    lienRecordingFee: 'purchasedVehicle.calculatedFields.lienRecordingFee',
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                },
                registration: {
                    consts: {
                        willVehicleEnterStateBeforeSubmitted: true,
                    },
                },
                owner: {
                    ssn: 'purchasedVehicle.registrationDetails.ssn',
                },
            },
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.MOTORCYCLE,
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
    },
    [StateAbbreviation.AZ]: {
        abbreviation: StateAbbreviation.AZ,
        supportsRON: false,
        name: StateName.AZ,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 12.71,
            estimatedTitlingFees: 4,
        },
        taxes: {
            salesTaxPercentage: 0.056,
            variableFee: 25,
        },
        insurance: {
            optional: false,
            insuranceName: 'Arizona Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 0,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: true,
            mustBeInStateForMilitary: true,
            exemptVehicleTypes: [VehicleType.MOPED],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 15000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
            miscellaneous: [],
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.MOPED,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        titlingAndRegistration: {
            stateReqs: {
                lienholder1: {
                    // AZ has strict requirements on how the lienholder name and address must match the electronic lienholder information
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
                vehicle: {
                    consts: { feeExemption: false },
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    manufacturesSuggestedRetailPrice: 'purchasedVehicle.basePrice',
                },
            },
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: AZ_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: AZ_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: AZ_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: AZ_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.PASSENGER]: AZ_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.OHV]: AZ_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ATV]: AZ_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: AZ_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: AZ_VEHICLE_TYPE_ENUM.PASSENGER,
                },
            },
        },
    },
    [StateAbbreviation.AR]: {
        abbreviation: StateAbbreviation.AR,
        supportsRON: false,
        name: StateName.AR,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 220,
            estimatedTitlingFees: 10,
        },
        taxes: {
            salesTaxPercentage: 0.065,
            variableFee: 10,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.MOPED,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'Arkansas Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 45,
            maxDaysUntilEffective: 0,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: true,
            mustBeInState: false,
            mustBeInStateForMilitary: true,
            miscellaneous: [
                'Out of state insurance will be accepted in the form of a current binder showing at least $25,000/$50,000/$25,000 coverage.',
            ],
            exemptVehicleTypes: [VehicleType.MOPED],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
            documentProofNotes: 'Your policy cannot expire within the next 45 days. Out of state insurance will be accepted in the form of a current binder showing at least $25,000/$50,000/$25,000 coverage.',
        },
        titlingAndRegistration: {
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: AR_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: AR_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: AR_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: AR_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.PASSENGER]: AR_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.OHV]: AR_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ATV]: AR_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: AR_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: AR_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                cylinders: {
                    [INTERNAL_CYLINDER_TYPE_ENUM.ZERO]: AR_CYLINDER_TYPE_ENUM.ZERO,
                    [INTERNAL_CYLINDER_TYPE_ENUM.FOUR]: AR_CYLINDER_TYPE_ENUM.FOUR,
                },
            },
            stateReqs: {
                vehicle: {
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    cylinders: 'oemVehicle.cylinders',
                    motoCubicCentimeters: 'oemVehicle.motoCubicCentimeters',
                },
                lienholder1: {
                    consts: {
                        electronicLien: true,
                        inStateELT: true,
                    },
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
            },
        },
    },
    [StateAbbreviation.CA]: {
        abbreviation: StateAbbreviation.CA,
        supportsRON: false,
        name: StateName.CA,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
            ID_DOCUMENT_TYPE_ENUM.PASSPORT,
        ],
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 297,
            estimatedTitlingFees: 0,
        },
        taxes: {
            salesTaxPercentage: 0.1,
            variableFee: 30,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.MOTORCYCLE,
                    VehicleType.MOPED,
                    VehicleType.PASSENGER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.YES,
        insurance: {
            optional: false,
            insuranceName: '',
            minFieldsToCollect: [],
            minDaysValid: 0,
            maxDaysUntilEffective: 0,
            proofRequired: false,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 15000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 30000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 5000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        titlingAndRegistration: {
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: CA_FUEL_TYPE_ENUM.GASOLINE,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: CA_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: CA_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: CA_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.PASSENGER]: CA_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.OHV]: CA_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ATV]: CA_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ORV]: CA_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.LOW_SPEED]: CA_VEHICLE_TYPE_ENUM.PASSENGER,
                },
            },
            stateReqs: {
                vehicle: {
                    consts: {
                        feeExemption: false,
                        odometerReadingIn: 'Miles',
                        taxesPaidToAnotherState: false,
                        transmission: 'Automatic',
                    },
                    milesPerHour: 'oemVehicle.milesPerhour',
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    motorcycleEngineNumber: 'purchasedVehicle.calculatedFields.motorcycleEngineNumber',
                    certifiedEmissionsVehicle: 'oemVehicle.certifiedEmissionsVehicle',
                    nonResidentServiceFee: 'purchasedVehicle.calculatedFields.nonResidentServiceFee',
                    dateFirstOperated: 'purchasedVehicle.calculatedFields.dateFirstOperated',
                },
                registration: {
                    addressIsInUnincorporatedArea: 'purchasedVehicle.addressIsInUnincorporatedArea',
                },
                owner: {
                    agentFirstName: 'purchasedVehicle.calculatedFields.agentFirstName',
                    agentMiddleName: 'purchasedVehicle.calculatedFields.agentMiddleName',
                    agentLastName: 'purchasedVehicle.calculatedFields.agentLastName',
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                },
            },
        },
    },
    [StateAbbreviation.CO]: {
        abbreviation: StateAbbreviation.CO,
        supportsRON: false,
        name: StateName.CO,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
            ID_DOCUMENT_TYPE_ENUM.PASSPORT,
        ],
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'Colorado Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 60,
            maxDaysUntilEffective: 0,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: false, // not explicitly mentioned in the VITU packet
            mustBeInState: true, // true for some counties, false for others. Setting to the more restrictive fo now
            mustBeInStateForMilitary: true, // same as above
            miscellaneous: [
                'Counties requiring Colorado-specific insurance: Alamosa, Bent, Chaffee, Ceyenne, Clear Creek, Conejos, Crowley, Custer, Eagle, El Paso, Gilpin, Lamier, Logan, Mesa, Moffat, Park, Phillips, Prowers, Pueblo, Routt, Sedgwick, Weld, Yuma. \n If out of state insurance is provided, proof in the form of a declarations page showing minimum limits of 25/50/15 is required',
            ],
            exemptVehicleTypes: [],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 15000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
            ],
        },
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 113.48,
            estimatedTitlingFees: 7.2,
        },
        taxes: {
            salesTaxPercentage: 0.095,
            variableFee: 35,
            remitTaxesDirectly: true, // indicates that Ekho is remitting taxes directly to the state/county and the third-party vendor is not responsible for remitting taxes
        },
        titlingAndRegistration: {
            stateReqs: {
                owner: {
                    idType: 'purchasedVehicle.calculatedFields.idType',
                    issuingState: 'purchasedVehicle.calculatedFields.issuingState',
                    licenseExpirationDate: 'purchasedVehicle.calculatedFields.licenseExpirationDate',
                    consts: { dlNotMatchName: false },
                },
                vehicle: {
                    numberOfLienholder: 'purchasedVehicle.calculatedFields.numberOfLienholder',
                    manufacturesSuggestedRetailPrice: 'purchasedVehicle.basePrice',
                    consts: {
                        isVehicleBeingShippedToOwner: true,
                        sellerSalesTaxAccountNumber: TAX_CONSTS.COsellerSalesTaxAccountNumber,
                        sellerCitySalesTaxAccountNumber: TAX_CONSTS.COsellerCitySalesTaxAccountNumber,
                    },
                },
                registration: {
                    keepColoradoWildPass: 'purchasedVehicle.registrationDetails.keepColoradoWildPass',
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                },
                // dlNotMatchName may be relevant
                // Seller's CO Sales Tax Account #
                // Seller's CO City Sales Tax Account #
                // Include Keep Colorado Wild Pass?
            },
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: CO_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: CO_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: CO_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: CO_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: CO_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: CO_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.PASSENGER]: CO_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.OHV]: CO_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ATV]: CO_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ORV]: CO_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.LOW_SPEED]: CO_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                bodyType: {
                    [INTERNAL_BODY_TYPE_ENUM.MOTORCYCLE]: CO_BODY_TYPE_ENUM.MOTORCYCLE,
                    [INTERNAL_BODY_TYPE_ENUM.CABRIOLET]: CO_BODY_TYPE_ENUM.UTILITY_PASSENGER_SUV,
                    [INTERNAL_BODY_TYPE_ENUM.UTILITY_TRUCK]: CO_BODY_TYPE_ENUM.UTILITY_TRUCK,
                },
                bodyTypeId: {
                    [INTERNAL_BODY_TYPE_ENUM.MOTORCYCLE]: CO_BODY_TYPE_ID_ENUM.MOTORCYCLE,
                    [INTERNAL_BODY_TYPE_ENUM.CABRIOLET]: CO_BODY_TYPE_ID_ENUM.UTILITY_PASSENGER_SUV,
                    [INTERNAL_BODY_TYPE_ENUM.UTILITY_TRUCK]: CO_BODY_TYPE_ID_ENUM.UTILITY_TRUCK,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: CO_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: CO_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: CO_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: CO_COLOR_ENUM.DARKBLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: CO_COLOR_ENUM.LIGHTBLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: CO_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: CO_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: CO_COLOR_ENUM.STEEL,
                    [INTERNAL_COLOR_ENUM.COPPER]: CO_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: CO_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: CO_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: CO_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: CO_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: CO_COLOR_ENUM.DARKGREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: CO_COLOR_ENUM.LIGHTGREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: CO_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: CO_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: CO_COLOR_ENUM.MAROON,
                    [INTERNAL_COLOR_ENUM.ORANGE]: CO_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: CO_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: CO_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: CO_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: CO_COLOR_ENUM.SILVER,
                    [INTERNAL_COLOR_ENUM.TAN]: CO_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: CO_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: CO_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: CO_COLOR_ENUM.YELLOW,
                },
            },
        },
    },
    [StateAbbreviation.CT]: {
        abbreviation: StateAbbreviation.CT,
        supportsRON: false,
        name: StateName.CT,
        requiresInStateLicense: false,
        insurance: {
            optional: false,
            insuranceName: 'Connecticut Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 45,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: true,
            mustBeInState: true,
            mustBeInStateForMilitary: true,
            miscellaneous: [
                'For vehicles registered to a business the insurance must list the company name as the named insured',
            ],
            exemptVehicleTypes: [VehicleType.MOPED],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
            ],
            acceptableDocumentProof: [INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD],
            documentProofNotes: 'Requires official insurance card noting that it is Connecticut Insurance',
        },
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
            ID_DOCUMENT_TYPE_ENUM.PASSPORT,
        ],
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 78,
            estimatedTitlingFees: 50,
        },
        taxes: {
            salesTaxPercentage: 0.0635,
            variableFee: 40,
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    motoCubicCentimeters: 'oemVehicle.motoCubicCentimeters',
                    numberOfWheels: 'oemVehicle.numberOfWheels',
                    milesPerHour: 'oemVehicle.milesPerhour',
                },
                lienholder1: {
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
            },
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: CT_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: CT_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: CT_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: CT_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.PASSENGER]: CT_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.OHV]: CT_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ATV]: CT_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: CT_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: CT_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: CT_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: CT_USE_TYPE_ENUM.COMMERCIAL,
                },
            },
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ], // CT does not require titling of OHVs
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
    },
    [StateAbbreviation.DC]: {
        abbreviation: StateAbbreviation.DC,
        supportsRON: false,
        name: StateName.DC,
        requiresInStateLicense: true,
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        insurance: {
            optional: false,
            insuranceName: 'District Of Colombia Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 30,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: true,
            mustBeInState: true,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [VehicleType.MOPED],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 10000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 5000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
            documentProofNotes: 'Must list name of insurance company, policy number, name or names insured, and period of coverage for policy',
        },
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 72,
            estimatedTitlingFees: 26,
        },
        taxes: {
            salesTaxPercentage: 0.044,
            variableFee: 45,
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    cityMilePerGalone: 'oemVehicle.milePerGalone',
                },
                registration: {
                    consts: {
                        addressZonedForResidentialPermitParking: false,
                    },
                },
            },
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: DC_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: DC_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: DC_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: DC_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.PASSENGER]: DC_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.OHV]: DC_VEHICLE_TYPE_ENUM.LOW_SPEED,
                    [VehicleType.ATV]: DC_VEHICLE_TYPE_ENUM.LOW_SPEED,
                    [VehicleType.ORV]: DC_VEHICLE_TYPE_ENUM.LOW_SPEED,
                    [VehicleType.LOW_SPEED]: DC_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: DC_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: DC_USE_TYPE_ENUM.COMMERCIAL,
                },
            },
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
    },
    [StateAbbreviation.DE]: {
        abbreviation: StateAbbreviation.DE,
        supportsRON: false,
        isRoboticSigningEnabled: true,
        titlingAndRegistration: {
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: DE_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: DE_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: DE_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: DE_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.PASSENGER]: DE_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.TRUCK]: DE_VEHICLE_TYPE_ENUM.TRUCK,
                    [VehicleType.TRAILER]: DE_VEHICLE_TYPE_ENUM.TRAILER,
                    [VehicleType.COMMERCIAL]: DE_VEHICLE_TYPE_ENUM.COMMERCIAL,
                    [VehicleType.LOW_SPEED]: DE_VEHICLE_TYPE_ENUM.PASSENGER,
                },
            },
            stateReqs: {
                vehicle: {
                    consts: {
                        poaAppointee: 'Test',
                        wasPreviouslyTitled: false,
                    },
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                },
            },
        },
        insurance: {
            optional: false,
            // insuranceName: TO DO,
            minFieldsToCollect: [],
            // minDaysValid: TO DO,
            // maxDaysUntilEffective: TO DO,
            // proofRequired: TO DO,
            // certificateRequired: TO DO,
            // buyerMustBeNamedInsured: TO DO,
            // mustBeInState: TO DO,
            // mustBeInStateForMilitary: TO DO,
            // miscellaneous: TO DO,
            exemptVehicleTypes: [VehicleType.MOPED],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 10000,
                },
                {
                    code: VehicleCoverageCodes.PERSONAL_INJURY_PROTECTION,
                    name: VehicleCoverageFriendlyNames.PERSONAL_INJURY_PROTECTION,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 15000,
                },
                {
                    code: VehicleCoverageCodes.PERSONAL_INJURY_PROTECTION,
                    name: VehicleCoverageFriendlyNames.PERSONAL_INJURY_PROTECTION,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 30000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 30,
            estimatedTitlingFees: 35,
        },
        taxes: {
            salesTaxPercentage: 0.0,
            variableFee: 0, // Setting as 0 now but haven't checked vitu
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.MOPED,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ], // DE does not require titling of OHVs
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
    },
    [StateAbbreviation.FL]: {
        abbreviation: StateAbbreviation.FL,
        supportsRON: false,
        name: StateName.FL,
        requiresInStateLicense: false,
        useDealerServiceFee: true, // Used to show that the dealer service fee field should be used instead of the documentFees field
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
            ID_DOCUMENT_TYPE_ENUM.PASSPORT,
        ],
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 62.85,
            estimatedTitlingFees: 77.25,
        },
        taxes: {
            salesTaxPercentage: 0.06,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'Florida Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 0,
            maxDaysUntilEffective: null,
            proofRequired: false,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: ['the 5-digit FL insurance code must be listed'],
            exemptVehicleTypes: [VehicleType.MOPED],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 10000,
                },
                {
                    code: VehicleCoverageCodes.PERSONAL_INJURY_PROTECTION,
                    name: VehicleCoverageFriendlyNames.PERSONAL_INJURY_PROTECTION,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT, // Assuming this type based on given info
                    amount: 10000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        titlingAndRegistration: {
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: FL_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: FL_FUEL_TYPE_ENUM.ELECTRIC,
                    // add more when vehicles of new types are supported
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: FL_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: FL_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.PASSENGER]: FL_VEHICLE_TYPE_ENUM.AUTO,
                    [VehicleType.OHV]: FL_VEHICLE_TYPE_ENUM.MOTORCYCLE, // VITU API does not include tax estimates for OHVs when using the OHV vehicle type but we know from CG that taxes are needed for these sales. For now pointing OHV to MOTORCYCLE to ensure tax estimates are included when we calculate fee estimates for these deals
                    [VehicleType.ATV]: FL_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.ORV]: FL_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.LOW_SPEED]: FL_VEHICLE_TYPE_ENUM.AUTO,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: FL_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: FL_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: FL_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: FL_COLOR_ENUM.DARKBLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: FL_COLOR_ENUM.LIGHTBLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: FL_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: FL_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: FL_COLOR_ENUM.CHROMESTEEL,
                    [INTERNAL_COLOR_ENUM.COPPER]: FL_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: FL_COLOR_ENUM.CREAMIVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: FL_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: FL_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: FL_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: FL_COLOR_ENUM.DARKGREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: FL_COLOR_ENUM.LIGHTGREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: FL_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: FL_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: FL_COLOR_ENUM.MAROONBURGUNDY,
                    [INTERNAL_COLOR_ENUM.ORANGE]: FL_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: FL_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: FL_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: FL_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: FL_COLOR_ENUM.SILVERALUMINUM,
                    [INTERNAL_COLOR_ENUM.TAN]: FL_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: FL_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: FL_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: FL_COLOR_ENUM.YELLOW,
                },
            },
            stateReqs: {
                vehicle: {
                    odometerUnit: 'oemVehicle.odometer',
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    lienRecordingFee: 'purchasedVehicle.calculatedFields.lienRecordingFee',
                    motoCubicCentimeters: 'oemVehicle.motoCubicCentimeters',
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
                registration: {
                    consts: {
                        requestedTitleType: FL_TITLE_TYPE_ENUM.PAPER,
                    },
                },
            },
        },
    },
    [StateAbbreviation.GA]: {
        abbreviation: StateAbbreviation.GA,
        supportsRON: false,
        name: StateName.GA,
        requiresInStateLicense: true,
        acceptableIdentityDocuments: [ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE], // allowed for someone signing on behalf of business or military members only
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 37.58,
            estimatedTitlingFees: 18,
        },
        taxes: {
            salesTaxPercentage: 0.07,
            variableFee: 60,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ], // GA does not require titling of OHVs
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'Georgia Motor Vehicle Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: null,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: true,
            buyerMustBeNamedInsured: false,
            mustBeInState: true,
            mustBeInStateForMilitary: true,
            miscellaneous: [
                "the insurance company must submit the vehicle insurance information into the Georgia Electronic Insurance Compliance System (GEICS) Database no more than 30 days prior to the DMV's processing date.",
            ],
            exemptVehicleTypes: [VehicleType.MOPED],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        titlingAndRegistration: {
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: GA_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: GA_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: GA_FUEL_TYPE_ENUM.ELECTRIC,
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: GA_FUEL_TYPE_ENUM.GAS,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: GA_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOPED]: GA_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOTORCYCLE]: GA_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.ATV]: GA_VEHICLE_TYPE_ENUM.LOW_SPEED_VEHICLE,
                    [VehicleType.ORV]: GA_VEHICLE_TYPE_ENUM.LOW_SPEED_VEHICLE,
                    [VehicleType.LOW_SPEED]: GA_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                cylinders: {
                    [INTERNAL_CYLINDER_TYPE_ENUM.ZERO]: GA_CYLINDER_TYPE_ENUM.ZERO,
                    [INTERNAL_CYLINDER_TYPE_ENUM.FOUR]: GA_CYLINDER_TYPE_ENUM.FOUR,
                    // TODO add the ones actually being used
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: GA_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: GA_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: GA_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: GA_COLOR_ENUM.DARKBLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: GA_COLOR_ENUM.LIGHTBLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: GA_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: GA_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: GA_COLOR_ENUM.CHROMESTEEL,
                    [INTERNAL_COLOR_ENUM.COPPER]: GA_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: GA_COLOR_ENUM.CREAMIVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: GA_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: GA_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: GA_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: GA_COLOR_ENUM.DARKGREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: GA_COLOR_ENUM.LIGHTGREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: GA_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: GA_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: GA_COLOR_ENUM.MAROONBURGUNDY,
                    [INTERNAL_COLOR_ENUM.ORANGE]: GA_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: GA_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: GA_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: GA_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: GA_COLOR_ENUM.SILVERALUMINUM,
                    [INTERNAL_COLOR_ENUM.TAN]: GA_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: GA_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: GA_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: GA_COLOR_ENUM.YELLOW,
                },
            },
            stateReqs: {
                vehicle: {
                    consts: {
                        isOwnerMilitaryDependent: false,
                        isOwnerVeteran: false,
                        isOwnerSpouseOfMilitary: false,
                        feeExemption: false,
                    },
                    cylinders: 'oemVehicle.cylinders', // assume this already has the correct value
                },
                lienholder1: {
                    // GA has strict requirements on how the lienholder name and address must match the electronic lienholder information
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                },
            },
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
    },
    [StateAbbreviation.HI]: {
        abbreviation: StateAbbreviation.HI,
        supportsRON: false,
        insurance: {
            optional: false,
            // insuranceName: TO DO,
            minFieldsToCollect: [],
            // minDaysValid: TO DO,
            // maxDaysUntilEffective: TO DO,
            // proofRequired: TO DO,
            // certificateRequired: TO DO,
            // buyerMustBeNamedInsured: TO DO,
            // mustBeInState: TO DO,
            // mustBeInStateForMilitary: TO DO,
            // miscellaneous: TO DO,
            exemptVehicleTypes: [VehicleType.MOPED],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 20000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 40000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 10000,
                },
                {
                    code: VehicleCoverageCodes.PERSONAL_INJURY_PROTECTION,
                    name: VehicleCoverageFriendlyNames.PERSONAL_INJURY_PROTECTION,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 10000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 77.5,
            estimatedTitlingFees: 0,
        },
        taxes: {
            salesTaxPercentage: 0.04,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [],
                useTypes: [],
                fuelTypes: [],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                    VehicleType.PASSENGER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.LOW_SPEED,
                ], // HI does not require titling of OHVs
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
    },
    [StateAbbreviation.ID]: {
        abbreviation: StateAbbreviation.ID,
        supportsRON: false,
        name: StateName.ID,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
            ID_DOCUMENT_TYPE_ENUM.PASSPORT,
        ],
        inspectionRequired: INSPECTION_TYPE_ENUM.YES,
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    consts: {
                        odometerReadingIn: 'Miles',
                    },
                    primaryColor: 'oemVehicle.calculatedFields.primaryColor',
                    secondaryColor: 'oemVehicle.calculatedFields.secondaryColor',
                },
                owner: {
                    ssn: 'purchasedVehicle.registrationDetails.ssn',
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                },
            },
            vituEnum: {
                vehicleType: {
                    [VehicleType.PASSENGER]: ID_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: ID_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: ID_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.OHV]: ID_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ATV]: ID_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: ID_VEHICLE_TYPE_ENUM.UTV,
                    [VehicleType.LOW_SPEED]: ID_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: DEFAULT_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: DEFAULT_FUEL_TYPE_ENUM.ELECTRIC,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: ID_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: ID_USE_TYPE_ENUM.COMMERCIAL,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: ID_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: ID_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: ID_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: ID_COLOR_ENUM.DARKBLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: ID_COLOR_ENUM.LIGHTBLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: ID_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: ID_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: ID_COLOR_ENUM.CHROMESTEEL,
                    [INTERNAL_COLOR_ENUM.COPPER]: ID_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: ID_COLOR_ENUM.CREAMIVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: ID_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: ID_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: ID_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: ID_COLOR_ENUM.DARKGREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: ID_COLOR_ENUM.LIGHTGREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: ID_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: ID_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: ID_COLOR_ENUM.MAROONBURGUNDY,
                    [INTERNAL_COLOR_ENUM.ORANGE]: ID_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: ID_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: ID_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: ID_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: ID_COLOR_ENUM.SILVERALUMINUM,
                    [INTERNAL_COLOR_ENUM.TAN]: ID_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: ID_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: ID_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: ID_COLOR_ENUM.YELLOW,
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: '',
            minFieldsToCollect: [],
            minDaysValid: 0,
            maxDaysUntilEffective: 0,
            proofRequired: false,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 15000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 193.4,
            estimatedTitlingFees: 14,
        },
        taxes: {
            salesTaxPercentage: 0.06,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
    },
    [StateAbbreviation.IL]: {
        abbreviation: StateAbbreviation.IL,
        supportsRON: false,
        name: StateName.IL,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
            ID_DOCUMENT_TYPE_ENUM.PASSPORT,
        ],
        insurance: {
            optional: false,
            insuranceName: '',
            minFieldsToCollect: [],
            minDaysValid: 0,
            maxDaysUntilEffective: 0,
            proofRequired: false,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 20000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 41,
            estimatedTitlingFees: 165,
        },
        taxes: {
            salesTaxPercentage: 0.0625,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        titlingAndRegistration: {
            stateReqs: {
                owner: {
                    ownersAddressMatchOwnersId: 'purchasedVehicle.ownersAddressMatchOwnersId',
                    ssn: 'purchasedVehicle.registrationDetails.ssn',
                },
                vehicle: {
                    registrationDate: 'purchasedVehicle.calculatedFields.registrationDate', // VITU says this is not actually required but API fails without it
                    engineCapacity: 'oemVehicle.motoCubicCentimeters', // only needed for motorcycles
                    freightCharge: 'purchasedVehicle.calculatedFields.freightCharge',
                },
                lienholder1: {
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
            },
            vituEnum: {
                bodyTypeId: {
                    [INTERNAL_BODY_TYPE_ENUM.MOTORCYCLE]: IL_BODY_TYPE_ID_ENUM.MOTORCYCLE,
                    [INTERNAL_BODY_TYPE_ENUM.CABRIOLET]: IL_BODY_TYPE_ID_ENUM.CABRIOLET,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: IL_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: IL_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: IL_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.OHV]: IL_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ATV]: IL_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: IL_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: IL_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: IL_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: IL_FUEL_TYPE_ENUM.ELECTRIC,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: IL_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: IL_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: IL_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: IL_COLOR_ENUM.DARKBLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: IL_COLOR_ENUM.LIGHTBLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: IL_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: IL_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: IL_COLOR_ENUM.CHROMESTEEL,
                    [INTERNAL_COLOR_ENUM.COPPER]: IL_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: IL_COLOR_ENUM.CREAMIVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: IL_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: IL_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: IL_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: IL_COLOR_ENUM.DARKGREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: IL_COLOR_ENUM.LIGHTGREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: IL_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: IL_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: IL_COLOR_ENUM.MAROONBURGUNDY,
                    [INTERNAL_COLOR_ENUM.ORANGE]: IL_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: IL_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: IL_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: IL_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: IL_COLOR_ENUM.SILVERALUMINUM,
                    [INTERNAL_COLOR_ENUM.TAN]: IL_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: IL_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: IL_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: IL_COLOR_ENUM.YELLOW,
                },
            },
        },
    },
    [StateAbbreviation.IN]: {
        abbreviation: StateAbbreviation.IN,
        supportsRON: false,
        name: StateName.IN,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        inspectionRequired: INSPECTION_TYPE_ENUM.YES,
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    consts: {
                        feeExemption: false,
                    },
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    manufacturesSuggestedRetailPrice: 'purchasedVehicle.basePrice',
                },
                owner: {
                    ssn: 'purchasedVehicle.registrationDetails.ssn',
                },
            },
            vituEnum: {
                vehicleType: {
                    [VehicleType.PASSENGER]: IN_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOPED]: IN_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.MOTORCYCLE]: IN_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.OHV]: IN_VEHICLE_TYPE_ENUM.ORV,
                    [VehicleType.ATV]: IN_VEHICLE_TYPE_ENUM.ORV,
                    [VehicleType.ORV]: IN_VEHICLE_TYPE_ENUM.ORV,
                    [VehicleType.LOW_SPEED]: IN_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: IN_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: IN_FUEL_TYPE_ENUM.ELECTRIC,
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'Indiana Liability Insurance',
            minFieldsToCollect: null,
            minDaysValid: null,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: ['Must show the full policy number and Insurance company name.'],
            exemptVehicleTypes: [VehicleType.MOPED],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 41.35,
            estimatedTitlingFees: 15,
        },
        taxes: {
            salesTaxPercentage: 0.07,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
    },
    [StateAbbreviation.IA]: {
        abbreviation: StateAbbreviation.IA,
        supportsRON: false,
        name: StateName.IA,
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.PASSPORT,
        ],
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    consts: {
                        hasBeenSalvageRebuiltFloodDamage: false,
                    },
                    listPrice: 'purchasedVehicle.basePrice',
                    numberOfLienholder: 'purchasedVehicle.calculatedFields.numberOfLienholder',
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                },
            },
            vituEnum: {
                vehicleType: {
                    [VehicleType.PASSENGER]: IA_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: IA_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: IA_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.OHV]: IA_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ATV]: IA_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: IA_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.LOW_SPEED]: IA_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: IA_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: IA_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: IA_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: IA_FUEL_TYPE_ENUM.ELECTRIC,
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: '',
            minFieldsToCollect: [],
            minDaysValid: 0,
            maxDaysUntilEffective: 0,
            proofRequired: false,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 15000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 628.75,
            estimatedTitlingFees: 25,
        },
        taxes: {
            salesTaxPercentage: 0.05,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
    },
    [StateAbbreviation.KS]: {
        abbreviation: StateAbbreviation.KS,
        supportsRON: false,
        name: StateName.KS,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 139.75,
            estimatedTitlingFees: 10,
        },
        taxes: {
            salesTaxPercentage: 0.065,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        insurance: {
            optional: false,
            insuranceName: 'Kansas Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 0,
            maxDaysUntilEffective: 0,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [VehicleType.MOPED],
            // NerdWallet shows this one as being complicated. Speak to Rowan before figuring this out
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.PERSONAL_INJURY_PROTECTION,
                    name: VehicleCoverageFriendlyNames.PERSONAL_INJURY_PROTECTION,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 1, // Setting to this for now because it should make sure this coverage exists on the policy but will not have any limit requirements
                    // This is because the PIP coverage is itemized and currently canopy connecy doesn't list out all of these itemized components
                },
                // Leaving out itemized PIP for now as canopy does not support it
                // {
                // 	code: VehicleCoverageCodes.WAGE_EARNER_DISABILITY_BENEFITS,
                // 	name: VehicleCoverageFriendlyNames.WAGE_EARNER_DISABILITY_BENEFITS,
                // 	type: insuranceLevelTypesEnum.PER_DAY_LIMIT, // TODO: figure out what type this is (monthly limit)
                // 	amount: (900 * 12) / 365,
                // 	maxDays: 365, // TODO add logic to check this field
                // },
                // {
                // 	code: VehicleCoverageCodes.ESSENTIAL_SERVICES_DISABILITY_BENEFITS,
                // 	name: VehicleCoverageFriendlyNames.ESSENTIAL_SERVICES_DISABILITY_BENEFITS,
                // 	type: insuranceLevelTypesEnum.PER_DAY_LIMIT,
                // 	amount: 25,
                // 	maxDays: 365,
                // },
                // {
                // 	code: VehicleCoverageCodes.DEATH_BENEFIT,
                // 	name: VehicleCoverageFriendlyNames.DEATH_BENEFIT,
                // 	type: insuranceLevelTypesEnum.PER_PERSON_LIMIT, // TODO: figure out what type this is
                // 	amount: 2000,
                // },
                // {
                // 	code: VehicleCoverageCodes.DEATG_BENEFIT,
                // 	name: VehicleCoverageFriendlyNames.DEATH_BENEFIT,
                // 	type: insuranceLevelTypesEnum.PER_PERSON_LIMIT, // TODO: figure out what type this is
                // 	amount: 4500,
                // },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
            ],
            acceptableDocumentProof: [INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD],
        },
        titlingAndRegistration: {
            stateReqs: {
                registration: {
                    consts: { temporarilyLivingOutOfState: false },
                    applyingForWildlifeParksPermit: 'purchasedVehicle.registrationDetails.applyingForWildlifeParksPermit',
                },
                vehicle: {
                    manufacturesSuggestedRetailPrice: 'purchasedVehicle.basePrice',
                },
            },
            vituEnum: {
                vehicleType: {
                    [VehicleType.PASSENGER]: KS_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOPED]: KS_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.MOTORCYCLE]: KS_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.OHV]: KS_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ATV]: KS_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: KS_VEHICLE_TYPE_ENUM.ORV,
                    [VehicleType.LOW_SPEED]: KS_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: KS_FUEL_TYPE_ENUM.GASOLINE,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: KS_FUEL_TYPE_ENUM.ELECTRIC,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: KS_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: KS_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: KS_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: KS_COLOR_ENUM.DARKBLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: KS_COLOR_ENUM.LIGHTBLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: KS_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: KS_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: KS_COLOR_ENUM.CHROMESTEEL,
                    [INTERNAL_COLOR_ENUM.COPPER]: KS_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: KS_COLOR_ENUM.CREAMIVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: KS_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: KS_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: KS_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: KS_COLOR_ENUM.DARKGREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: KS_COLOR_ENUM.LIGHTGREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: KS_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: KS_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: KS_COLOR_ENUM.MAROONBURGUNDY,
                    [INTERNAL_COLOR_ENUM.ORANGE]: KS_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: KS_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: KS_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: KS_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: KS_COLOR_ENUM.SILVERALUMINUM,
                    [INTERNAL_COLOR_ENUM.TAN]: KS_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: KS_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: KS_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: KS_COLOR_ENUM.YELLOW,
                },
            },
        },
    },
    [StateAbbreviation.KY]: {
        abbreviation: StateAbbreviation.KY,
        supportsRON: false,
        name: StateName.KY,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        inspectionRequired: INSPECTION_TYPE_ENUM.AFTER_DELIVERY,
        titlingAndRegistration: {
            stateReqs: {
                owner: {
                    ssn: 'purchasedVehicle.registrationDetails.ssn',
                },
                vehicle: {
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                },
                registration: {
                    consts: {
                        completingVinInspection: true,
                    },
                },
            },
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: KY_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: KY_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: KY_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: KY_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: KY_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: KY_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: KY_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.OHV]: KY_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ATV]: KY_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: KY_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: KY_VEHICLE_TYPE_ENUM.PASSENGER,
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'Kentucky Liability Insurance',
            minFieldsToCollect: null,
            minDaysValid: null,
            maxDaysUntilEffective: 45,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: true,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [VehicleType.MOPED],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 22.25,
            estimatedTitlingFees: 9,
        },
        taxes: {
            salesTaxPercentage: 0.06,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
    },
    [StateAbbreviation.LA]: {
        abbreviation: StateAbbreviation.LA,
        supportsRON: false,
        name: StateName.LA,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 20,
            estimatedTitlingFees: 68.5,
        },
        taxes: {
            salesTaxPercentage: 0.0445,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'Louisiana Liability Insurance',
            minDaysValid: 30,
            maxDaysUntilEffective: 0,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [
                'Out of state insurance may be accepted if it meets Louisiana liability requirements, must provide a valid binder or declaration page showing at least $15,000/$30,000/$25,000 coverage. IMPORTANT INFORMATION: The insurance policy MUST demonstrate coverage of the purchased vehicle. Document MUST list the owner insured and full VIN of the vehicle purchased and cannot expire within the next 30 days at the time of submission.',
            ],
            minFieldsToCollect: [],
            exemptVehicleTypes: [VehicleType.MOPED],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 15000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 30000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
            ],
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    consts: { dealerMaintenanceAgreement: 0, manufacturesRebate: 0 },
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                },
            },
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: LA_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: LA_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: DEFAULT_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: DEFAULT_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: LA_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: LA_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: LA_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.OHV]: LA_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ATV]: LA_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: LA_VEHICLE_TYPE_ENUM.UTV,
                    [VehicleType.LOW_SPEED]: LA_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: LA_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: LA_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: LA_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: LA_COLOR_ENUM.DARKBLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: LA_COLOR_ENUM.LIGHTBLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: LA_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: LA_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: LA_COLOR_ENUM.CHROMESTEEL,
                    [INTERNAL_COLOR_ENUM.COPPER]: LA_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: LA_COLOR_ENUM.CREAMIVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: LA_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: LA_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: LA_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: LA_COLOR_ENUM.DARKGREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: LA_COLOR_ENUM.LIGHTGREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: LA_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: LA_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: LA_COLOR_ENUM.MAROONBURGUNDY,
                    [INTERNAL_COLOR_ENUM.ORANGE]: LA_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: LA_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: LA_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: LA_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: LA_COLOR_ENUM.SILVERALUMINUM,
                    [INTERNAL_COLOR_ENUM.TAN]: LA_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: LA_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: LA_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: LA_COLOR_ENUM.YELLOW,
                },
            },
        },
    },
    [StateAbbreviation.ME]: {
        abbreviation: StateAbbreviation.ME,
        supportsRON: false,
        name: StateName.ME,
        requiresInStateLicense: false,
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        insurance: {
            optional: false,
            insuranceName: 'Maine Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 45,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: true,
            mustBeInState: true,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 100000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 100000,
                },
                {
                    code: VehicleCoverageCodes.MEDICAL_PAYMENTS,
                    name: VehicleCoverageFriendlyNames.MEDICAL_PAYMENTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT, // Per person is the only possible type for this coverage
                    amount: 2000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 27,
            estimatedTitlingFees: 33,
        },
        taxes: {
            salesTaxPercentage: 0.079, // Sales Tax: 5.5% + Excise Tax: 2.4%
            variableFee: 0,
        },
        titlingAndRegistration: {
            stateReqs: {
                owner: {
                    ssn: 'purchasedVehicle.registrationDetails.ssn',
                },
                vehicle: {
                    consts: {
                        plateType: ME_PLATE_TYPE_ENUM.PLAIN_PLATE,
                    },
                    manufacturesSuggestedRetailPrice: 'purchasedVehicle.basePrice',
                },
            },
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: ME_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: ME_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: ME_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: ME_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.PASSENGER]: ME_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.OHV]: ME_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ATV]: ME_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: ME_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: ME_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: ME_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: ME_USE_TYPE_ENUM.COMMERCIAL,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: ME_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: ME_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: ME_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: ME_COLOR_ENUM.BLUEDARK,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: ME_COLOR_ENUM.BLUELIGHT,
                    [INTERNAL_COLOR_ENUM.BROWN]: ME_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: ME_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: ME_COLOR_ENUM.CHROMESTEEL,
                    [INTERNAL_COLOR_ENUM.COPPER]: ME_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: ME_COLOR_ENUM.CREAMIVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: ME_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: ME_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: ME_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: ME_COLOR_ENUM.GREENLIGHT,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: ME_COLOR_ENUM.GREENDARK,
                    [INTERNAL_COLOR_ENUM.IVORY]: ME_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: ME_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: ME_COLOR_ENUM.MAROONBURGUNDY,
                    [INTERNAL_COLOR_ENUM.ORANGE]: ME_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: ME_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: ME_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: ME_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: ME_COLOR_ENUM.SILVERALUMINUM,
                    [INTERNAL_COLOR_ENUM.TAN]: ME_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: ME_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: ME_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: ME_COLOR_ENUM.YELLOW,
                },
            },
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ], // ME does not require titling for OHVs
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
    },
    [StateAbbreviation.MD]: {
        abbreviation: StateAbbreviation.MD,
        supportsRON: false,
        name: StateName.MD,
        acceptableIdentityDocuments: [ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE],
        insurance: {
            optional: false,
            insuranceName: 'Maryland Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: null,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: true,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 30000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 60000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 15000,
                },
                // Uninsured/Underinsured Motorist Coverage
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 30000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 60000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 15000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 210,
            estimatedTitlingFees: 100,
        },
        taxes: {
            salesTaxPercentage: 0.06, // Not specified by Vitu
            variableFee: 0, // Not specified by Vitu
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    motorcycleEngineNumber: 'purchasedVehicle.calculatedFields.motorcycleEngineNumber',
                    motoCubicCentimeters: 'oemVehicle.motoCubicCentimeters',
                    isCustomersPrimaryAddress: 'purchasedVehicle.calculatedFields.isCustomersPrimaryAddress',
                },
                registration: {
                    consts: {
                        hovDecal: false,
                    },
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                },
            },
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: MD_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: MA_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: MD_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: MD_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: MD_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: MD_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: MD_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.OHV]: MD_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ATV]: MD_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: MD_VEHICLE_TYPE_ENUM.UTV,
                    [VehicleType.LOW_SPEED]: MD_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                bodyType: {
                    [INTERNAL_BODY_TYPE_ENUM.MOTORCYCLE]: NY_BODY_TYPE_ENUM.MOTORCYCLE,
                    [INTERNAL_BODY_TYPE_ENUM.CABRIOLET]: NY_BODY_TYPE_ENUM.OTHER,
                },
            },
        },
        requiresInStateLicense: false,
    },
    [StateAbbreviation.MA]: {
        abbreviation: StateAbbreviation.MA,
        supportsRON: false,
        name: StateName.MA,
        requiresInStateLicense: false,
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
            ID_DOCUMENT_TYPE_ENUM.PASSPORT,
        ],
        insurance: {
            optional: false,
            insuranceName: 'Massachusetts Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: null,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: true,
            mustBeInStateForMilitary: true,
            miscellaneous: ['Official Insurance Stamp is required on TTLREG100 Document'],
            exemptVehicleTypes: [VehicleType.MOPED],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 20000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 40000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 5000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 20000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 40000,
                },
                {
                    code: VehicleCoverageCodes.PERSONAL_INJURY_PROTECTION,
                    name: VehicleCoverageFriendlyNames.PERSONAL_INJURY_PROTECTION,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 8000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 20,
            estimatedTitlingFees: 75,
        },
        taxes: {
            salesTaxPercentage: 0.0625,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        titlingAndRegistration: {
            stateReqs: {
                owner: {
                    idType: 'purchasedVehicle.calculatedFields.idType',
                    idNumber: 'purchasedVehicle.calculatedFields.idNumber',
                    licenseExpirationDate: 'purchasedVehicle.calculatedFields.licenseExpirationDate',
                    ssn: 'purchasedVehicle.registrationDetails.ssn',
                    issuedBy: 'purchasedVehicle.calculatedFields.issuedBy',
                },
                vehicle: {
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    registrationDate: 'purchasedVehicle.calculatedFields.registrationDate',
                    manufacturesSuggestedRetailPrice: 'purchasedVehicle.basePrice',
                    consts: {
                        feeExemption: false,
                        salesTaxPaidToSellingState: false,
                    },
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                },
            },
            vituEnum: {
                bodyType: {
                    [VehicleType.PASSENGER]: MA_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.COMMERCIAL]: MA_VEHICLE_TYPE_ENUM.COMMERCIAL,
                    [VehicleType.MOTORCYCLE]: MA_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: MA_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: MA_USE_TYPE_ENUM.COMMERCIAL,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: MA_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOPED]: MA_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.MOTORCYCLE]: MA_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.ATV]: MA_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: MA_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: MA_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: MA_COLOR_ENUM.YELLOW,
                    [INTERNAL_COLOR_ENUM.BLACK]: MA_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: MA_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: MA_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: MA_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: MA_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: MA_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: MA_COLOR_ENUM.SILVER,
                    [INTERNAL_COLOR_ENUM.COPPER]: MA_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: MA_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.GOLD]: MA_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: MA_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: MA_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: MA_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: MA_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: MA_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: MA_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: MA_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.ORANGE]: MA_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: MA_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.PURPLE]: MA_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: MA_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: MA_COLOR_ENUM.SILVER,
                    [INTERNAL_COLOR_ENUM.TAN]: MA_COLOR_ENUM.YELLOW,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: MA_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.WHITE]: MA_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: MA_COLOR_ENUM.YELLOW,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: MA_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: MA_FUEL_TYPE_ENUM.ELECTRIC,
                },
                idType: {
                    [INTERNAL_ID_TYPE_ENUM.MA_LICENSE_ID]: INTERNAL_ID_TYPE_ENUM.MA_LICENSE_ID,
                    [INTERNAL_ID_TYPE_ENUM.OUT_OF_STATE_LICENSE]: INTERNAL_ID_TYPE_ENUM.OUT_OF_STATE_LICENSE,
                    [INTERNAL_ID_TYPE_ENUM.OUT_OF_COUNTRY_LICENSE]: INTERNAL_ID_TYPE_ENUM.OUT_OF_COUNTRY_LICENSE,
                    [INTERNAL_ID_TYPE_ENUM.SOCIAL_SECURITY_NUMBER]: INTERNAL_ID_TYPE_ENUM.SOCIAL_SECURITY_NUMBER,
                    [INTERNAL_ID_TYPE_ENUM.LAWFUL_PRESENCE]: INTERNAL_ID_TYPE_ENUM.LAWFUL_PRESENCE,
                    [INTERNAL_ID_TYPE_ENUM.STATE_ID]: INTERNAL_ID_TYPE_ENUM.STATE_ID,
                    [INTERNAL_ID_TYPE_ENUM.DRIVER_LICENSE]: INTERNAL_ID_TYPE_ENUM.DRIVER_LICENSE,
                    [INTERNAL_ID_TYPE_ENUM.US_PASSPORT_PASSPORT_CARD]: INTERNAL_ID_TYPE_ENUM.US_PASSPORT_PASSPORT_CARD,
                    [INTERNAL_ID_TYPE_ENUM.VALID_US_MILITARY_ID]: INTERNAL_ID_TYPE_ENUM.VALID_US_MILITARY_ID,
                    [INTERNAL_ID_TYPE_ENUM.TRIBAL_IDENTIFICATION_CARD]: INTERNAL_ID_TYPE_ENUM.TRIBAL_IDENTIFICATION_CARD,
                    [INTERNAL_ID_TYPE_ENUM.US_CITIZENSHIP_DOCUMENT]: INTERNAL_ID_TYPE_ENUM.US_CITIZENSHIP_DOCUMENT,
                    [INTERNAL_ID_TYPE_ENUM.VALID_FOREIGN_PASSPORT]: INTERNAL_ID_TYPE_ENUM.VALID_FOREIGN_PASSPORT,
                    [INTERNAL_ID_TYPE_ENUM.CANADIAN_LICENSE_ID]: INTERNAL_ID_TYPE_ENUM.CANADIAN_LICENSE_ID,
                    [INTERNAL_ID_TYPE_ENUM.MILITARY_ID]: INTERNAL_ID_TYPE_ENUM.MILITARY_ID,
                    [INTERNAL_ID_TYPE_ENUM.PASSPORT]: INTERNAL_ID_TYPE_ENUM.PASSPORT,
                    [INTERNAL_ID_TYPE_ENUM.FOREIGN_ID]: INTERNAL_ID_TYPE_ENUM.FOREIGN_ID,
                },
                doors: {
                    [INTERNAL_DOORS_ENUM.TWO]: MA_DOORS_ENUM.TWO,
                    [INTERNAL_DOORS_ENUM.THREE]: MA_DOORS_ENUM.THREE,
                    [INTERNAL_DOORS_ENUM.FOUR]: MA_DOORS_ENUM.FOUR,
                    [INTERNAL_DOORS_ENUM.FIVE]: MA_DOORS_ENUM.FIVE,
                },
                transmission: {
                    [INTERNAL_TRANSMISSION_ENUM.AUTOMATIC]: INTERNAL_TRANSMISSION_ENUM.AUTOMATIC,
                    [INTERNAL_TRANSMISSION_ENUM.MANUAL]: INTERNAL_TRANSMISSION_ENUM.MANUAL,
                },
            },
        },
    },
    [StateAbbreviation.MI]: {
        name: StateName.MI,
        abbreviation: StateAbbreviation.MI,
        supportsRON: false,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
            ID_DOCUMENT_TYPE_ENUM.PASSPORT,
        ],
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'MI No-Fault Insurance',
            minFieldsToCollect: [],
            minDaysValid: 45,
            maxDaysUntilEffective: 0,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: true,
            mustBeInState: true,
            mustBeInStateForMilitary: true,
            miscellaneous: 'MI insurance statement acceptable in case the insurance card does not contain MI No-Fault Insurance',
            exemptVehicleTypes: [VehicleType.MOPED],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS. Note the complexity below
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 100000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 10000,
                },
                // If there's a separate coverage code for property protection within Michigan.
                // {
                // 	code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,  // Placeholder for actual code
                // 	name: "Property Protection within Michigan",  // Placeholder for friendly name
                // 	type: insuranceLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                // 	amount: 1000000,
                // },
            ],
            acceptableDocumentProof: [INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD],
            documentProofNotes: 'Must state Michigan Certificate of No-Fault Insurance on the card, include VIN, Year, Make, Policy #, and must not expire within 45 days of submitting',
        },
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 165,
            estimatedTitlingFees: 15,
        },
        taxes: {
            salesTaxPercentage: 0.06,
            variableFee: 0,
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    recreationalPassportFee: 'purchasedVehicle.registrationDetails.recreationalPassportFee',
                    manufacturesSuggestedRetailPrice: 'purchasedVehicle.basePrice',
                    consts: { plateType: MI_PLATE_TYPE_ENUM.PURE_MICHIGAN_PLATE },
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
            },
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: MI_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: MI_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: MI_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: MI_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: MI_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: MI_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.TRUCK]: MI_VEHICLE_TYPE_ENUM.TRUCK,
                    [VehicleType.MOPED]: MI_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.TRAILER]: MI_VEHICLE_TYPE_ENUM.TRAILER,
                    [VehicleType.OHV]: MI_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ATV]: MI_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: MI_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: MI_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                bodyType: {
                    [INTERNAL_BODY_TYPE_ENUM.MOTORCYCLE]: MI_BODY_TYPE_ENUM.MOTORCYCLE,
                    [INTERNAL_BODY_TYPE_ENUM.CABRIOLET]: MI_BODY_TYPE_ENUM.FOURDOOR,
                },
                bodyTypeId: {
                    [INTERNAL_BODY_TYPE_ENUM.MOTORCYCLE]: MI_BODY_TYPE_ID_ENUM.MOTORCYCLE,
                    [INTERNAL_BODY_TYPE_ENUM.CABRIOLET]: MI_BODY_TYPE_ID_ENUM.FOURDOOR,
                },
                // MI has no color enum so we're just going to use the color string as it is in INTERNAL
            },
        },
    },
    [StateAbbreviation.MN]: {
        name: StateName.MN,
        abbreviation: StateAbbreviation.MN,
        supportsRON: false,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
            ID_DOCUMENT_TYPE_ENUM.PASSPORT,
        ],
        // many other ID options allowed, but we're not going to support them for now
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 41,
            estimatedTitlingFees: 10.5,
        },
        taxes: {
            salesTaxPercentage: 0.06875,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'Liability Insurance',
            minFieldsToCollect: [
                MIN_FIELDS_TO_COLLECT.CARRIER_NAME,
                MIN_FIELDS_TO_COLLECT.POLICY_NUMBER,
                MIN_FIELDS_TO_COLLECT.EXPIRY_DATE,
            ],
            minDaysValid: 0,
            maxDaysUntilEffective: 0,
            proofRequired: false,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [
                'lienholder can buy insurance if owner does not and then charge to owner',
            ],
            exemptVehicleTypes: [],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 30000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 60000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 10000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PERSONAL_INJURY_PROTECTION,
                    name: VehicleCoverageFriendlyNames.PERSONAL_INJURY_PROTECTION,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 40000,
                    // 20000 for medical expenses and 20000 for non-medical expenses
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    consts: {
                        hasBeenDamaged: false,
                        manufacturesRebate: 0,
                    },
                    manufacturesSuggestedRetailPrice: 'purchasedVehicle.basePrice',
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    motorcycleEngineNumber: 'purchasedVehicle.calculatedFields.motorcycleEngineNumber', // This is only needed for motorcycles. How do we make sure we set this value when oems send us VIN for their motorcycle?
                    numberOfPassengers: 'oemVehicle.seatingCapacity',
                    registrationDate: 'purchasedVehicle.calculatedFields.registrationDate', // VITU says this is not actually required but API fails without it
                },
                lienholder1: {
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
            },
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: MN_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: MN_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: MN_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: MN_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: MN_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.ATV]: MN_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: MN_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.LOW_SPEED]: MN_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: MN_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: MN_USE_TYPE_ENUM.COMMERCIAL,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: MN_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: MN_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: MN_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: MN_COLOR_ENUM.DARKBLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: MN_COLOR_ENUM.LIGHTBLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: MN_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: MN_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: MN_COLOR_ENUM.CHROMESTEEL,
                    [INTERNAL_COLOR_ENUM.COPPER]: MN_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: MN_COLOR_ENUM.CREAMIVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: MN_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: MN_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: MN_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: MN_COLOR_ENUM.DARKGREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: MN_COLOR_ENUM.LIGHTGREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: MN_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: MN_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: MN_COLOR_ENUM.MAROONBURGUNDY,
                    [INTERNAL_COLOR_ENUM.ORANGE]: MN_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: MN_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: MN_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: MN_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: MN_COLOR_ENUM.SILVERALUMINUM,
                    [INTERNAL_COLOR_ENUM.TAN]: MN_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: MN_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: MN_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: MN_COLOR_ENUM.YELLOW,
                },
            },
        },
    },
    [StateAbbreviation.MS]: {
        name: StateName.MS,
        abbreviation: StateAbbreviation.MS,
        supportsRON: false,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 23,
            estimatedTitlingFees: 9,
        },
        taxes: {
            salesTaxPercentage: 0.07,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'MS Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 0,
            maxDaysUntilEffective: 0,
            proofRequired: false,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    consts: {
                        remittingAdValoremForOwner: false,
                        plateType: MS_PLATE_TYPE_ENUM.REGULAR_PLATE,
                    },
                    manufacturesSuggestedRetailPrice: 'purchasedVehicle.totalPrice',
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                },
            },
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: MS_FUEL_TYPE_ENUM.GASOLINE,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: MS_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: MS_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: MS_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.DUAL_SPORT]: MS_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.OHV]: MS_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.TRUCK]: MS_VEHICLE_TYPE_ENUM.TRUCK,
                    [VehicleType.MOPED]: MS_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.TRAILER]: MS_VEHICLE_TYPE_ENUM.TRAILER,
                    [VehicleType.ATV]: MS_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.ORV]: MS_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.LOW_SPEED]: MS_VEHICLE_TYPE_ENUM.PASSENGER,
                },
            },
        },
    },
    [StateAbbreviation.MO]: {
        abbreviation: StateAbbreviation.MO,
        supportsRON: false,
        name: StateName.MO,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 35.5,
            estimatedTitlingFees: 14.5,
        },
        taxes: {
            salesTaxPercentage: 0.04225,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [VehicleType.OHV, VehicleType.DUAL_SPORT, VehicleType.ATV],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE, VehicleType.ORV],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'Missouri Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 30,
            maxDaysUntilEffective: 0,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [VehicleType.MOPED],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_RECEIPT,
            ],
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    consts: {
                        regPeriodType: MO_REG_PERIOD_TYPE_ENUM.TWO_YEARS,
                    },
                    numberOfWheels: 'oemVehicle.calculatedFields.numberOfMotorcycleWheels',
                },
                lienholder1: {
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
            },
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: MO_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: MO_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: MO_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: MO_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.OHV]: MO_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.MOPED]: MO_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.ATV]: MO_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: MO_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: MO_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: MO_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: MO_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: MO_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: MO_COLOR_ENUM.DARKBLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: MO_COLOR_ENUM.LIGHTBLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: MO_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: MO_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: MO_COLOR_ENUM.CHROMESTEEL,
                    [INTERNAL_COLOR_ENUM.COPPER]: MO_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: MO_COLOR_ENUM.CREAMIVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: MO_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: MO_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: MO_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: MO_COLOR_ENUM.DARKGREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: MO_COLOR_ENUM.LIGHTGREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: MO_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: MO_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: MO_COLOR_ENUM.MAROONBURGUNDY,
                    [INTERNAL_COLOR_ENUM.ORANGE]: MO_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: MO_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: MO_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: MO_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: MO_COLOR_ENUM.SILVERALUMINUM,
                    [INTERNAL_COLOR_ENUM.TAN]: MO_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: MO_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: MO_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: MO_COLOR_ENUM.YELLOW,
                },
                numberOfWheels: {
                    [INTERNAL_NUMBER_WHEELS_ENUM.TWO]: MO_NUMBER_WHEELS_ENUM.TWO,
                    [INTERNAL_NUMBER_WHEELS_ENUM.THREE]: MO_NUMBER_WHEELS_ENUM.THREE,
                },
            },
        },
    },
    [StateAbbreviation.MT]: {
        abbreviation: StateAbbreviation.MT,
        supportsRON: false,
        name: StateName.MT,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 313.33,
            estimatedTitlingFees: 10.3,
        },
        taxes: {
            salesTaxPercentage: 0,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE, VehicleType.LOW_SPEED],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'MT Liability Insurance',
            minDaysValid: 0,
            maxDaysUntilEffective: 0,
            proofRequired: true, // proof not actually required but we want to include it because registration will fail if insurance is not bought on the vehicle
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [
                'Proof not required but submitting because will be checked at state level',
            ],
            minFieldsToCollect: [],
            exemptVehicleTypes: [VehicleType.MOPED],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 20000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    consts: { regPeriodType: MT_REG_PERIOD_TYPE_ENUM.PERMANENT },
                    manufacturesSuggestedRetailPrice: 'purchasedVehicle.basePrice',
                    odometerUnit: 'oemVehicle.odometer',
                },
                owner: {
                    ownersAddressMatchOwnersId: 'purchasedVehicle.ownersAddressMatchOwnersId',
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
            },
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: MT_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: MT_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: MT_FUEL_TYPE_ENUM.GASOLINE,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: MT_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: MT_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: MT_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: MT_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.OHV]: MT_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ATV]: MT_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: MT_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: MT_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                bodyType: {
                    [INTERNAL_BODY_TYPE_ENUM.MOTORCYCLE]: MT_BODY_TYPE_ENUM.MOTORCYCLE,
                    [INTERNAL_BODY_TYPE_ENUM.CABRIOLET]: MT_BODY_TYPE_ENUM.SPORT_UTILITY_TRUCK,
                },
                bodyTypeId: {
                    [INTERNAL_BODY_TYPE_ENUM.MOTORCYCLE]: MT_BODY_TYPE_ID_ENUM.MOTORCYCLE,
                    [INTERNAL_BODY_TYPE_ENUM.CABRIOLET]: MT_BODY_TYPE_ID_ENUM.SPORT_UTILITY_TRUCK,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: MT_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: MT_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: MT_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: MT_COLOR_ENUM.DARKBLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: MT_COLOR_ENUM.LIGHTBLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: MT_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: MT_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: MT_COLOR_ENUM.CHROMESTEEL,
                    [INTERNAL_COLOR_ENUM.COPPER]: MT_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: MT_COLOR_ENUM.CREAMIVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: MT_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: MT_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: MT_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: MT_COLOR_ENUM.DARKGREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: MT_COLOR_ENUM.LIGHTGREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: MT_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: MT_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: MT_COLOR_ENUM.MAROONBURGUNDY,
                    [INTERNAL_COLOR_ENUM.ORANGE]: MT_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: MT_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: MT_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: MT_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: MT_COLOR_ENUM.SILVERALUMINUM,
                    [INTERNAL_COLOR_ENUM.TAN]: MT_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: MT_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: MT_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: MT_COLOR_ENUM.YELLOW,
                },
            },
        },
    },
    [StateAbbreviation.NE]: {
        abbreviation: StateAbbreviation.NE,
        supportsRON: false,
        name: StateName.NE,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        insurance: {
            optional: false,
            insuranceName: 'Nebraska Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: null,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: true,
            mustBeInState: true,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [VehicleType.MOPED],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 104.8,
            estimatedTitlingFees: 10,
        },
        taxes: {
            salesTaxPercentage: 0.055,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    consts: {
                        applyingForDisabledVeteranTaxExemption: false,
                        numberOfPlates: 1,
                    },
                    manufacturesSuggestedRetailPrice: 'purchasedVehicle.basePrice',
                },
                owner: {
                    ssn: 'purchasedVehicle.registrationDetails.ssn',
                },
            },
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: NE_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: NE_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: NE_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: NE_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: NE_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOPED]: NE_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.MOTORCYCLE]: NE_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.OHV]: NE_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ATV]: NE_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: NE_VEHICLE_TYPE_ENUM.UTV,
                    [VehicleType.LOW_SPEED]: NE_VEHICLE_TYPE_ENUM.PASSENGER,
                },
            },
        },
        requiresInStateLicense: false,
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
    },
    [StateAbbreviation.NV]: {
        abbreviation: StateAbbreviation.NV,
        supportsRON: false,
        name: StateName.NV,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        insurance: {
            optional: false,
            insuranceName: 'Nevada Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 60,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: true,
            mustBeInState: true,
            mustBeInStateForMilitary: true,
            miscellaneous: [
                'Proof of Insurance must be an insurance card. Binders, Verification of Insurance, and Declarations Pages will not be accepted',
            ],
            exemptVehicleTypes: [VehicleType.MOPED],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 20000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.MEDICAL_PAYMENTS,
                    name: VehicleCoverageFriendlyNames.MEDICAL_PAYMENTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 1000,
                },
            ],
            acceptableDocumentProof: [INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD],
        },
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 127,
            estimatedTitlingFees: 28.25,
        },
        taxes: {
            salesTaxPercentage: 0.08375,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    consts: {
                        feeExemption: false,
                        regPeriodType: NV_REG_PERIOD_TYPE_ENUM.THREE_YEARS,
                        plateType: NV_PLATE_TYPE_ENUM.AUTISM_AWARENESS_PLATE,
                    },
                    manufacturesSuggestedRetailPrice: 'purchasedVehicle.basePrice',
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                },
            },
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: NV_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: NV_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: NV_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.DIESEL]: NV_FUEL_TYPE_ENUM.DIESEL,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: NV_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: NV_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: NV_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.TRUCK]: NV_VEHICLE_TYPE_ENUM.TRUCK,
                    [VehicleType.TRAILER]: NV_VEHICLE_TYPE_ENUM.TRAILER,
                    [VehicleType.MOPED]: NV_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.OHV]: NV_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ATV]: NV_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: NV_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.LOW_SPEED]: NV_VEHICLE_TYPE_ENUM.PASSENGER,
                },
            },
        },
        requiresInStateLicense: false,
        inspectionRequired: INSPECTION_TYPE_ENUM.AFTER_DELIVERY,
    },
    [StateAbbreviation.NH]: {
        abbreviation: StateAbbreviation.NH,
        supportsRON: false,
        name: StateName.NE,
        requiresInStateLicense: true,
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        insurance: {
            optional: false,
            insuranceName: 'New Hampshire Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: null,
            maxDaysUntilEffective: null,
            proofRequired: false,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [VehicleType.MOPED],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.MEDICAL_PAYMENTS,
                    name: VehicleCoverageFriendlyNames.MEDICAL_PAYMENTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 1000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 46.4,
            estimatedTitlingFees: 25,
        },
        taxes: {
            salesTaxPercentage: 0.0,
            variableFee: 0,
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    manufacturesSuggestedRetailPrice: 'purchasedVehicle.basePrice',
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident', // only relevant when the owner is military
                },
            },
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: NH_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: NH_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: NH_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.PASSENGER]: NH_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOPED]: NH_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.OHV]: NH_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ATV]: NH_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ORV]: NH_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.LOW_SPEED]: NH_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: INTERNAL_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: INTERNAL_USE_TYPE_ENUM.COMMERCIAL,
                },
            },
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
    },
    [StateAbbreviation.NJ]: {
        abbreviation: StateAbbreviation.NJ,
        supportsRON: false,
        name: StateName.NJ,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
            ID_DOCUMENT_TYPE_ENUM.PASSPORT,
        ],
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        requiresInStateLicense: false,
        insurance: {
            optional: false,
            insuranceName: 'New Jersey Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: null,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: true,
            mustBeInState: true,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 15000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 5000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
            ],
        },
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 65,
            estimatedTitlingFees: 85,
        },
        taxes: {
            salesTaxPercentage: 0.0625,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        titlingAndRegistration: {
            stateReqs: {
                owner: {
                    ssn: 'purchasedVehicle.registrationDetails.ssn',
                    eyeColor: 'purchasedVehicle.registrationDetails.eyeColor',
                    // corpCode: 'purchasedVehicle.registrationDetails.corpCode',
                },
                vehicle: {
                    consts: {
                        numberOfAxles: 2,
                        registrationDiscount: false,
                        regPeriodType: NJ_REG_PERIOD_TYPE_ENUM.THREE_YEARS,
                    },
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    milePerGalone: 'oemVehicle.milePerGalone',
                    zeroEmissions: 'oemVehicle.calculatedFields.zeroEmissions',
                    numberOfLienholder: 'purchasedVehicle.calculatedFields.numberOfLienholder',
                },
                lienholder1: {
                    consts: {
                        inStateELT: false,
                    },
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
            },
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: NJ_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: NJ_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: NJ_FUEL_TYPE_ENUM.GASOLINE,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: NJ_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: NJ_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: NJ_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: NJ_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.ATV]: NJ_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: NJ_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: NJ_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                bodyType: {
                    [INTERNAL_BODY_TYPE_ENUM.MOTORCYCLE]: NJ_BODY_TYPE_ENUM.MOTORCYCLE,
                    [INTERNAL_BODY_TYPE_ENUM.FOURDOOR]: NJ_BODY_TYPE_ENUM.FOURDOOR,
                },
                bodyTypeId: {
                    [INTERNAL_BODY_TYPE_ENUM.MOTORCYCLE]: NJ_BODY_TYPE_ID_ENUM.MOTORCYCLE,
                    [INTERNAL_BODY_TYPE_ENUM.FOURDOOR]: NY_BODY_TYPE_ID_ENUM.OTHER,
                },
            },
        },
    },
    [StateAbbreviation.NM]: {
        abbreviation: StateAbbreviation.NM,
        supportsRON: false,
        name: StateName.NM,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 33,
            estimatedTitlingFees: 5,
        },
        taxes: {
            salesTaxPercentage: 0.04,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [VehicleType.OHV],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        insurance: {
            optional: false,
            insuranceName: 'New Mexico Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 0,
            maxDaysUntilEffective: 0,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [
                'If out of state insurance is provided, a declarations page showing a minimum coverage of 25/50/10 is required, along with form MVD-11268.',
                '"The insurance policy must demonstrate coverage of the purchased vehicle. VIN of the purchased vehicle MUST be on the insurance card.',
            ],
            exemptVehicleTypes: [VehicleType.MOPED],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 10000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    consts: {
                        manufacturesRebate: 0,
                        regPeriodType: NM_REG_PERIOD_TYPE_ENUM.TWO_YEARS,
                        plateType: NM_PLATE_TYPE_ENUM.CENTENNIAL_PLATE,
                    },
                    primaryColor: 'oemVehicle.calculatedFields.primaryColor',
                },
                lienholder1: {
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                    maturityDate: 'purchasedVehicle.calculatedFields.maturityDate',
                },
            },
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: NM_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: NM_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: NM_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: NM_FUEL_TYPE_ENUM.ELECTRIC,
                    [INTERNAL_FUEL_TYPE_ENUM.DIESEL]: NM_FUEL_TYPE_ENUM.DIESEL,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: NM_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: NM_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: NM_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.TRUCK]: NM_VEHICLE_TYPE_ENUM.TRUCK,
                    [VehicleType.ATV]: NM_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: NM_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.OHV]: NM_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: NM_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: NM_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: NM_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: NM_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: NM_COLOR_ENUM.DARKBLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: NM_COLOR_ENUM.LIGHTBLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: NM_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: NM_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: NM_COLOR_ENUM.CHROMESTEEL,
                    [INTERNAL_COLOR_ENUM.COPPER]: NM_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: NM_COLOR_ENUM.CREAMIVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: NM_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: NM_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: NM_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: NM_COLOR_ENUM.DARKGREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: NM_COLOR_ENUM.LIGHTGREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: NM_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: NM_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: NM_COLOR_ENUM.MAROONBURGUNDY,
                    [INTERNAL_COLOR_ENUM.ORANGE]: NM_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: NM_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: NM_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: NM_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: NM_COLOR_ENUM.SILVERALUMINUM,
                    [INTERNAL_COLOR_ENUM.TAN]: NM_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: NM_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: NM_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: NM_COLOR_ENUM.YELLOW,
                },
            },
        },
    },
    [StateAbbreviation.NY]: {
        abbreviation: StateAbbreviation.NY,
        supportsRON: false,
        name: StateName.NY,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
            ID_DOCUMENT_TYPE_ENUM.PASSPORT,
        ],
        // other identification options are acceptable, but we are not supporting them at this time
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 65,
            estimatedTitlingFees: 50,
        },
        taxes: {
            salesTaxPercentage: 0.04,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.AFTER_DELIVERY,
        insurance: {
            optional: false,
            insuranceName: 'New York Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 45,
            maxDaysUntilEffective: 45,
            proofRequired: true,
            certificateRequired: true,
            buyerMustBeNamedInsured: true,
            mustBeInState: true,
            mustBeInStateForMilitary: false,
            miscellaneous: [
                'the owner’s name must exactly match the owner’s driver’s license without exceeding 20 characters for individuals, and 40 characters for business (20 characters per line)',
            ],
            exemptVehicleTypes: [],
            // Minimums completed by Rowan
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.LIABILITY_FOR_DEATH,
                    name: VehicleCoverageFriendlyNames.LIABILITY_FOR_DEATH,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.LIABILITY_FOR_DEATH,
                    name: VehicleCoverageFriendlyNames.LIABILITY_FOR_DEATH,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 100000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 10000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PERSONAL_INJURY_PROTECTION,
                    name: VehicleCoverageFriendlyNames.PERSONAL_INJURY_PROTECTION,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 50000,
                },
            ],
            acceptableDocumentProof: [INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD],
            documentProofNotes: 'Must be NY issued insurance card with 2-D Barcode on the card. The name on the policy must match your name exactly as written on your drivers license (within 20 character limit).',
        },
        titlingAndRegistration: {
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: NY_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: NY_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: NY_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: NY_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: NY_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.PASSENGER]: NY_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOPED]: NY_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.OHV]: NY_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ATV]: NY_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: NY_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.LOW_SPEED]: NY_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                bodyType: {
                    [INTERNAL_BODY_TYPE_ENUM.MOTORCYCLE]: NY_BODY_TYPE_ENUM.MOTORCYCLE,
                    [INTERNAL_BODY_TYPE_ENUM.CABRIOLET]: NY_BODY_TYPE_ENUM.OTHER,
                },
                bodyTypeId: {
                    [INTERNAL_BODY_TYPE_ENUM.MOTORCYCLE]: NY_BODY_TYPE_ID_ENUM.MOTORCYCLE,
                    [INTERNAL_BODY_TYPE_ENUM.CABRIOLET]: NY_BODY_TYPE_ID_ENUM.OTHER,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: NY_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: NY_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: NY_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: NY_COLOR_ENUM.DARKBLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: NY_COLOR_ENUM.LIGHTBLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: NY_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: NY_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: NY_COLOR_ENUM.CHROMESTEEL,
                    [INTERNAL_COLOR_ENUM.COPPER]: NY_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: NY_COLOR_ENUM.CREAMIVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: NY_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: NY_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: NY_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: NY_COLOR_ENUM.DARKGREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: NY_COLOR_ENUM.LIGHTGREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: NY_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: NY_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: NY_COLOR_ENUM.MAROONBURGUNDY,
                    [INTERNAL_COLOR_ENUM.ORANGE]: NY_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: NY_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: NY_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: NY_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: NY_COLOR_ENUM.SILVERALUMINUM,
                    [INTERNAL_COLOR_ENUM.TAN]: NY_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: NY_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: NY_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: NY_COLOR_ENUM.YELLOW,
                },
            },
            stateReqs: {
                owner: {
                    ssn: 'purchasedVehicle.registrationDetails.ssn',
                },
                vehicle: {
                    cylinders: 'oemVehicle.cylinders',
                    odometerUnit: 'oemVehicle.odometer',
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    lienRecordingFee: 'purchasedVehicle.calculatedFields.lienRecordingFee',
                    numberOfLienholder: 'purchasedVehicle.calculatedFields.numberOfLienholder',
                    seatingCapacity: 'oemVehicle.seatingCapacity',
                    consts: {
                        feeExemption: false,
                        applyingForSalesTaxCredit: false,
                        applyingForCountyTaxExemption: false,
                        wasAlteredToIncreaseCapacity: false,
                        hasBeenWreckedDestroyedDamaged: false,
                        hasBeenModifiedWithoutExtendingChassisWheelbase: false,
                    },
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                },
            },
        },
    },
    [StateAbbreviation.NC]: {
        abbreviation: StateAbbreviation.NC,
        supportsRON: false,
        name: StateName.NC,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    consts: {
                        plateType: NC_PLATE_TYPE_ENUM.FIRST_IN_FLIGHT_PLATE,
                        dealerServiceFee: 0,
                    },
                },
                owner: {
                    addressOnLicense: 'purchasedVehicle.calculatedFields.addressOnLicense',
                },
                lienholder1: {
                    consts: {
                        inStateELT: false,
                    },
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
            },
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: NC_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: NC_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: DEFAULT_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: DEFAULT_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: NC_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.PASSENGER]: NC_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOPED]: NC_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.OHV]: NC_VEHICLE_TYPE_ENUM.LOW_SPEED,
                    [VehicleType.ATV]: NC_VEHICLE_TYPE_ENUM.LOW_SPEED,
                    [VehicleType.ORV]: NC_VEHICLE_TYPE_ENUM.LOW_SPEED,
                    [VehicleType.LOW_SPEED]: NC_VEHICLE_TYPE_ENUM.PASSENGER,
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'North Carolina Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 30,
            maxDaysUntilEffective: 0, // not specified
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: true,
            mustBeInStateForMilitary: true,
            miscellaneous: [],
            exemptVehicleTypes: [],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 30000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 60000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 30000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 60000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 25.5,
            estimatedTitlingFees: 66.75,
        },
        taxes: {
            salesTaxPercentage: 0.0475,
            variableFee: 0,
        },
    },
    [StateAbbreviation.ND]: {
        abbreviation: StateAbbreviation.ND,
        supportsRON: false,
        name: StateName.ND,
        insurance: {
            optional: true,
            insuranceName: 'North Dakota Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 0,
            maxDaysUntilEffective: null,
            proofRequired: false,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [VehicleType.MOPED],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PERSONAL_INJURY_PROTECTION,
                    name: VehicleCoverageFriendlyNames.PERSONAL_INJURY_PROTECTION,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 30000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: true,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
        ],
        fees: {
            estimatedRegistrationFees: 275.5,
            estimatedTitlingFees: 5,
        },
        taxes: {
            salesTaxPercentage: 0.05,
            variableFee: 0,
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.MOTORCYCLE,
                    VehicleType.PASSENGER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [
                    INTERNAL_FUEL_TYPE_ENUM.GASOLINE,
                    INTERNAL_FUEL_TYPE_ENUM.ELECTRIC,
                    INTERNAL_FUEL_TYPE_ENUM.HYBRID_GASOLINE_ELECTRIC,
                ],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [VehicleType.OHV],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    yearFirstRegistered: 'purchasedVehicle.calculatedFields.yearFirstRegistered',
                    consts: {
                        tribalExempt: false,
                    },
                },
            },
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: ND_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: ND_FUEL_TYPE_ENUM.ELECTRIC,
                    [INTERNAL_FUEL_TYPE_ENUM.HYBRID_GASOLINE_ELECTRIC]: ND_FUEL_TYPE_ENUM.PLUG_IN_HYBRID,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: ND_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.PASSENGER]: ND_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOPED]: ND_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.TRUCK]: ND_VEHICLE_TYPE_ENUM.TRUCK,
                    [VehicleType.TRAILER]: ND_VEHICLE_TYPE_ENUM.TRAILER,
                    [VehicleType.OHV]: ND_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.VESSEL]: ND_VEHICLE_TYPE_ENUM.VESSEL,
                    [VehicleType.LOW_SPEED]: ND_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.ATV]: ND_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ORV]: ND_VEHICLE_TYPE_ENUM.OHV,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: ND_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: ND_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: ND_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: ND_COLOR_ENUM.BLUEDARK,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: ND_COLOR_ENUM.BLUELIGHT,
                    [INTERNAL_COLOR_ENUM.BROWN]: ND_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: ND_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: ND_COLOR_ENUM.CHROMESTEEL,
                    [INTERNAL_COLOR_ENUM.COPPER]: ND_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: ND_COLOR_ENUM.CREAMIVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: ND_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: ND_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: ND_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: ND_COLOR_ENUM.GREENDARK,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: ND_COLOR_ENUM.GREENLIGHT,
                    [INTERNAL_COLOR_ENUM.IVORY]: ND_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: ND_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: ND_COLOR_ENUM.MAROONBURGUNDY,
                    [INTERNAL_COLOR_ENUM.ORANGE]: ND_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: ND_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: ND_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: ND_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: ND_COLOR_ENUM.SILVERALUMINUM,
                    [INTERNAL_COLOR_ENUM.TAN]: ND_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: ND_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: ND_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: ND_COLOR_ENUM.YELLOW,
                },
            },
        },
    },
    [StateAbbreviation.OH]: {
        abbreviation: StateAbbreviation.OH,
        supportsRON: false,
        name: StateName.OH,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        insurance: {
            optional: false,
            insuranceName: 'Ohio Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: null,
            maxDaysUntilEffective: null,
            proofRequired: false,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [VehicleType.MOPED],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 40.5,
            estimatedTitlingFees: 15,
        },
        taxes: {
            salesTaxPercentage: 0.0575,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.MOTORCYCLE,
                    VehicleType.MOPED,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        titlingAndRegistration: {
            stateReqs: {
                owner: {
                    ssn: 'purchasedVehicle.registrationDetails.ssn',
                    consts: {
                        isOwnerMinor: false,
                    },
                },
                vehicle: {
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                },
                registration: {},
                seller: {},
                lienholder1: {
                    // AZ has strict requirements on how the lienholder name and address must match the electronic lienholder information
                    consts: {
                        inStateELT: false,
                    },
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
            },
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: OH_FUEL_TYPE_ENUM.GASOLINE,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: OH_FUEL_TYPE_ENUM.ELECTRIC_OR_HYBRID,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: OH_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.PASSENGER]: OH_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOPED]: OH_VEHICLE_TYPE_ENUM.MOPED,
                    // TODO - add a way to get from Stark VARG to motorcycle -- below is a bad long-term approach
                    [VehicleType.OHV]: OH_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ATV]: OH_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: OH_VEHICLE_TYPE_ENUM.UTV,
                    [VehicleType.LOW_SPEED]: OH_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: OH_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: OH_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: OH_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: OH_COLOR_ENUM.DARKBLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: OH_COLOR_ENUM.LIGHTBLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: OH_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: OH_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: OH_COLOR_ENUM.CHROME,
                    [INTERNAL_COLOR_ENUM.COPPER]: OH_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: OH_COLOR_ENUM.CREAM,
                    [INTERNAL_COLOR_ENUM.GOLD]: OH_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: OH_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: OH_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: OH_COLOR_ENUM.DARKGREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: OH_COLOR_ENUM.LIGHTGREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: OH_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: OH_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: OH_COLOR_ENUM.MAROON,
                    [INTERNAL_COLOR_ENUM.ORANGE]: OH_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: OH_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: OH_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: OH_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: OH_COLOR_ENUM.SILVER,
                    [INTERNAL_COLOR_ENUM.TAN]: OH_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: OH_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: OH_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: OH_COLOR_ENUM.YELLOW,
                },
            },
        },
    },
    [StateAbbreviation.OK]: {
        abbreviation: StateAbbreviation.OK,
        supportsRON: false,
        name: StateName.OK,
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 227.5,
            estimatedTitlingFees: 11,
        },
        taxes: {
            salesTaxPercentage: 0.0125,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'Oklahoma Liability Insurance',
            minDaysValid: 30,
            maxDaysUntilEffective: 0,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: true,
            mustBeInStateForMilitary: false,
            miscellaneous: ['Documents must list NAIC#'],
            minFieldsToCollect: [],
            exemptVehicleTypes: [],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    consts: {
                        manufacturesRebate: 0,
                        hasBeenDamagedByCollisionOrOtherOccurrence: false,
                        hasBeenRecoveredFromTheft: false,
                        hasVehicleSufferedWaterOrFloodDamage: false,
                        feeExemption: false,
                    },
                    numberOfWheels: 'oemVehicle.numberOfWheels',
                    areTireRimSizes19OrLess: 'oemVehicle.areTireRimSizes19OrLess',
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
            },
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: OK_FUEL_TYPE_ENUM.GASOLINE,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: OK_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: OK_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.PASSENGER]: OK_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOPED]: OK_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.OHV]: OK_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.ATV]: OK_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.ORV]: OK_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.LOW_SPEED]: OK_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: OK_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.BLACK]: OK_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: OK_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: OK_COLOR_ENUM.DARKBLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: OK_COLOR_ENUM.LIGHTBLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: OK_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: OK_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: OK_COLOR_ENUM.SILVER,
                    [INTERNAL_COLOR_ENUM.COPPER]: OK_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: OK_COLOR_ENUM.CREAM,
                    [INTERNAL_COLOR_ENUM.GOLD]: OK_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: OK_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: OK_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: OK_COLOR_ENUM.DARKGREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: OK_COLOR_ENUM.LIGHTGREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: OK_COLOR_ENUM.CREAM,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: OK_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: OK_COLOR_ENUM.MAROON,
                    [INTERNAL_COLOR_ENUM.ORANGE]: OK_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: OK_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: OK_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: OK_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: OK_COLOR_ENUM.SILVER,
                    [INTERNAL_COLOR_ENUM.TAN]: OK_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: OK_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: OK_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: OK_COLOR_ENUM.YELLOW,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: OK_USE_TYPE_ENUM.COMMERCIAL,
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: OK_USE_TYPE_ENUM.PERSONAL,
                },
            },
        },
    },
    [StateAbbreviation.OR]: {
        abbreviation: StateAbbreviation.OR,
        supportsRON: false,
        name: StateName.OR,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 179,
            estimatedTitlingFees: 192,
        },
        taxes: {
            salesTaxPercentage: 0.0,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    minFieldsToCollect: [
                        MIN_FIELDS_TO_COLLECT.CARRIER_NAME,
                        MIN_FIELDS_TO_COLLECT.POLICY_NUMBER, // required for VITU
                    ],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'Oregon Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 0,
            maxDaysUntilEffective: 0,
            proofRequired: false, // recommended by VITU but not required
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 20000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PERSONAL_INJURY_PROTECTION,
                    name: VehicleCoverageFriendlyNames.PERSONAL_INJURY_PROTECTION,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 15000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    consts: {
                        manufacturesRebate: 0,
                        regPeriodType: OR_REG_PERIOD_TYPE_ENUM.FOUR_YEARS,
                    },
                    // milePerGalone is not required for electric vehicles or motorcycles
                    seatingCapacity: 'oemVehicle.seatingCapacity',
                    inOreGo: 'purchasedVehicle.registrationDetails.inOreGo', // collected
                },
                registration: {
                    temporarilyLivingOutOfState: 'purchasedVehicle.registrationDetails.temporarilyLivingOutOfState', // collected
                },
            },
            vituEnum: {
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: OR_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.PASSENGER]: OR_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOPED]: OR_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.OHV]: OR_VEHICLE_TYPE_ENUM.MOTORCYCLE, // VITU API does not include tax estimates for OHVs when using the OHV vehicle type but we know from CG that taxes are needed for these sales. For now pointing OHV to MOTORCYCLE to ensure tax estimates are included when we calculate fee estimates for these deals
                    [VehicleType.ATV]: OR_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: OR_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: OR_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: OR_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: OR_USE_TYPE_ENUM.COMMERCIAL,
                },
                bodyTypeId: {
                    [INTERNAL_BODY_TYPE_ENUM.MOTORCYCLE]: OR_BODY_TYPE_ID_ENUM.MOTORCYCLE,
                    [INTERNAL_BODY_TYPE_ENUM.CABRIOLET]: OR_BODY_TYPE_ID_ENUM.CONVERTIBLE,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: OR_FUEL_TYPE_ENUM.GASOLINE,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: OR_FUEL_TYPE_ENUM.ELECTRIC,
                },
            },
        },
    },
    [StateAbbreviation.PA]: {
        abbreviation: StateAbbreviation.PA,
        supportsRON: false,
        name: StateName.PA,
        requiresInStateLicense: true, // not required for military
        acceptableIdentityDocuments: [ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE],
        insurance: {
            optional: false,
            insuranceName: 'Pennsylvania Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: null,
            maxDaysUntilEffective: 0,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: true,
            mustBeInState: true,
            mustBeInStateForMilitary: false,
            miscellaneous: [], // If military, must also submit a letter from the insurance provider
            exemptVehicleTypes: [],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 15000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 30000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 5000,
                },
                {
                    code: VehicleCoverageCodes.MEDICAL_PAYMENTS,
                    name: VehicleCoverageFriendlyNames.MEDICAL_PAYMENTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 5000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
            ],
            documentProofNotes: 'If using Declarations Page or Binder it must be signed by insurance agent. When using Binder, NAIC number must be listed on the document.',
        },
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 77,
            estimatedTitlingFees: 67,
        },
        taxes: {
            salesTaxPercentage: 0.06,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        titlingAndRegistration: {
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: PA_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: PA_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: PA_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: PA_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.PASSENGER]: PA_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.OHV]: PA_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ATV]: PA_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: PA_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: PA_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: PA_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: PA_USE_TYPE_ENUM.COMMERCIAL,
                },
                bodyTypeId: {
                    [INTERNAL_BODY_TYPE_ENUM.MOTORCYCLE]: PA_BODY_TYPE_ID_ENUM.MOTORCYCLE,
                    [INTERNAL_BODY_TYPE_ENUM.CABRIOLET]: PA_BODY_TYPE_ID_ENUM.CABRIOLET,
                },
            },
            stateReqs: {
                vehicle: {
                    processingFee: 'purchasedVehicle.calculatedFields.processingFee',
                    lienRecordingFee: 'purchasedVehicle.calculatedFields.lienRecordingFee',
                    consts: {
                        regPeriodType: PA_REG_PERIOD_TYPE_ENUM.TWO_YEARS,
                        serviceContracts: 0,
                    },
                },
                registration: {
                    consts: {
                        disabledPlatePlacard: false,
                    },
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                },
            },
        },
    },
    [StateAbbreviation.RI]: {
        abbreviation: StateAbbreviation.RI,
        supportsRON: false,
        name: StateName.RI,
        requiresInStateLicense: false,
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        insurance: {
            optional: false,
            insuranceName: 'Rhode Island Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: null,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: true,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
            ID_DOCUMENT_TYPE_ENUM.PASSPORT,
        ],
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 97.5,
            estimatedTitlingFees: 50,
        },
        taxes: {
            salesTaxPercentage: 0.07,
            variableFee: 0,
        },
        titlingAndRegistration: {
            stateReqs: {
                owner: {
                    ssn: 'purchasedVehicle.registrationDetails.ssn',
                },
                vehicle: {
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    milesPerHour: 'oemVehicle.milesPerhour',
                    motoCubicCentimeters: 'oemVehicle.motoCubicCentimeters',
                    numberOfPassengers: 'oemVehicle.seatingCapacity',
                    numberOfWheels: 'oemVehicle.numberOfWheels',
                },
                lienholder1: {
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
            },
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: RI_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: RI_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: RI_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: RI_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.PASSENGER]: RI_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.OHV]: RI_VEHICLE_TYPE_ENUM.MOTORSCOOTER,
                    [VehicleType.ATV]: RI_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.ORV]: RI_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.LOW_SPEED]: RI_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: RI_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: RI_USE_TYPE_ENUM.COMMERCIAL,
                },
            },
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
    },
    [StateAbbreviation.SC]: {
        abbreviation: StateAbbreviation.SC,
        supportsRON: false,
        name: StateName.SC,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 130,
            estimatedTitlingFees: 15,
        },
        taxes: {
            salesTaxPercentage: 0.06,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [VehicleType.OHV],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'South Carolina Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 45,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: true,
            buyerMustBeNamedInsured: false,
            mustBeInState: true,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [VehicleType.MOPED],
            // Minimum levels completed using NerdWallet's listing: https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORIST_BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        titlingAndRegistration: {
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: DEFAULT_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: DEFAULT_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: SC_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: SC_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.PASSENGER]: SC_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.OHV]: SC_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ATV]: SC_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: SC_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: SC_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: SC_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: SC_USE_TYPE_ENUM.COMMERCIAL,
                },
            },
            stateReqs: {
                vehicle: {
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    isOwnerSpouseOfMilitary: 'purchasedVehicle.registrationDetails.isOwnerSpouseOfMilitary',
                    consts: {
                        disability: false,
                        feeExemption: false,
                        numberOfRegYears: 2,
                    },
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
                // insurance: {
                // 	companyName: 'purchasedVehicle.insurance.carrierName',
                // },
            },
        },
    },
    [StateAbbreviation.SD]: {
        abbreviation: StateAbbreviation.SD,
        supportsRON: false,
        name: StateName.SD,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        insurance: {
            optional: false,
            insuranceName: 'South Dakota Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: null,
            maxDaysUntilEffective: null,
            proofRequired: false,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [VehicleType.MOPED],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 116,
            estimatedTitlingFees: 10,
        },
        taxes: {
            salesTaxPercentage: 0.04,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    odometerUnit: 'oemVehicle.odometer',
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    numberOfWheels: 'oemVehicle.calculatedFields.numberOfMotorcycleWheels',
                    engineCapacity: 'oemVehicle.motoCubicCentimeters',
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
            },
            vituEnum: {
                numberOfWheels: {
                    [INTERNAL_NUMBER_WHEELS_ENUM.TWO]: SD_NUMBER_OF_WHEELS_ENUM.TWO,
                    [INTERNAL_NUMBER_WHEELS_ENUM.THREE]: SD_NUMBER_OF_WHEELS_ENUM.THREE,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: SD_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: SD_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: SD_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.DIESEL]: SD_FUEL_TYPE_ENUM.DIESEL,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: SD_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: SD_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: SD_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: SD_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.TRUCK]: SD_VEHICLE_TYPE_ENUM.TRUCK,
                    [VehicleType.OHV]: SD_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.TRAILER]: SD_VEHICLE_TYPE_ENUM.TRAILER,
                    [VehicleType.VESSEL]: SD_VEHICLE_TYPE_ENUM.VESSEL,
                    [VehicleType.ATV]: SD_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ORV]: SD_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.LOW_SPEED]: SD_VEHICLE_TYPE_ENUM.PASSENGER,
                },
            },
        },
        requiresInStateLicense: false,
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
    },
    [StateAbbreviation.TN]: {
        abbreviation: StateAbbreviation.TN,
        supportsRON: false,
        name: StateName.TN,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE],
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 27.5,
            estimatedTitlingFees: 12.5,
        },
        taxes: {
            salesTaxPercentage: 0.07,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'Tennessee Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 60,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            // Eh not really, look into this more
            mustBeInState: true,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [VehicleType.MOPED],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 15000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        titlingAndRegistration: {
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: TN_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: TN_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: DEFAULT_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: DEFAULT_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: TN_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: TN_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.PASSENGER]: TN_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.OHV]: TN_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ATV]: TN_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ORV]: TN_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.LOW_SPEED]: TN_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: TN_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: TN_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: TN_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: TN_COLOR_ENUM.BLUEDARK,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: TN_COLOR_ENUM.BLUELIGHT,
                    [INTERNAL_COLOR_ENUM.BROWN]: TN_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: TN_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: TN_COLOR_ENUM.CHROME,
                    [INTERNAL_COLOR_ENUM.COPPER]: TN_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: TN_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: TN_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: TN_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: TN_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: TN_COLOR_ENUM.GREENDARK,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: TN_COLOR_ENUM.GREENLIGHT,
                    [INTERNAL_COLOR_ENUM.IVORY]: TN_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: TN_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: TN_COLOR_ENUM.MAROON,
                    [INTERNAL_COLOR_ENUM.ORANGE]: TN_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: TN_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: TN_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: TN_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: TN_COLOR_ENUM.SILVER,
                    [INTERNAL_COLOR_ENUM.TAN]: TN_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: TN_COLOR_ENUM.TURQUOISEBLUE,
                    [INTERNAL_COLOR_ENUM.WHITE]: TN_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: TN_COLOR_ENUM.YELLOW,
                },
            },
            stateReqs: {
                owner: {
                    ownersAddressMatchOwnersId: 'purchasedVehicle.ownersAddressMatchOwnersId',
                },
                vehicle: {
                    upperColor: 'purchasedVehicle.calculatedFields.upperColor',
                    lowerColor: 'purchasedVehicle.calculatedFields.lowerColor',
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    lienRecordingFee: 'purchasedVehicle.calculatedFields.lienRecordingFee',
                    consts: { numberOfAxles: 2 },
                },
            },
        },
    },
    [StateAbbreviation.TX]: {
        abbreviation: StateAbbreviation.TX,
        supportsRON: false,
        name: StateName.TX,
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 464,
            estimatedTitlingFees: 28,
        },
        taxes: {
            salesTaxPercentage: 0.0625,
            variableFee: 0,
        },
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
            ID_DOCUMENT_TYPE_ENUM.PASSPORT,
        ],
        // other identification is allowed, but we are not supporting this right now
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.AFTER_DELIVERY, // TODO indicate that the buyer needs to do the inspection?
        insurance: {
            optional: false,
            insuranceName: 'Insurance',
            minFieldsToCollect: [],
            minDaysValid: 60,
            maxDaysUntilEffective: 0,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: true,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 30000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 60000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        titlingAndRegistration: {
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: TX_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: TX_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: TX_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.PASSENGER]: TX_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOPED]: TX_VEHICLE_TYPE_ENUM.MOPED,
                    // TODO - add a way to get from Stark VARG to motorcycle -- below is a bad long-term approach
                    [VehicleType.OHV]: TX_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.ATV]: TX_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.ORV]: TX_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.LOW_SPEED]: TX_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                bodyTypeId: {
                    [INTERNAL_BODY_TYPE_ENUM.MOTORCYCLE]: TX_BODY_TYPE_ID_ENUM.MOTORCYCLE,
                    [INTERNAL_BODY_TYPE_ENUM.CABRIOLET]: TX_BODY_TYPE_ID_ENUM.CONVERTIBLE,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: TX_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: TX_USE_TYPE_ENUM.COMMERCIAL,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: TX_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: TX_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: TX_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: TX_COLOR_ENUM.DARKBLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: TX_COLOR_ENUM.LIGHTBLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: TX_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: TX_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: TX_COLOR_ENUM.CHROMESTEEL,
                    [INTERNAL_COLOR_ENUM.COPPER]: TX_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: TX_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: TX_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: TX_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: TX_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: TX_COLOR_ENUM.DARKGREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: TX_COLOR_ENUM.LIGHTGREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: TX_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: TX_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: TX_COLOR_ENUM.MAROONBURGUNDY,
                    [INTERNAL_COLOR_ENUM.ORANGE]: TX_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: TX_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: TX_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: TX_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: TX_COLOR_ENUM.SILVERALUMINUM,
                    [INTERNAL_COLOR_ENUM.TAN]: TX_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: TX_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: TX_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: TX_COLOR_ENUM.YELLOW,
                },
            },
            stateReqs: {
                registration: {
                    consts: {
                        willVehicleEnterStateBeforeSubmitted: true,
                    },
                },
                vehicle: {
                    consts: {
                        manufacturesRebate: 0,
                        newResidentFee: false, // only required when vehicle was registered out-of-state
                    },
                    primaryColor: 'oemVehicle.calculatedFields.primaryColor', // calculated same as color field
                    secondaryColor: 'oemVehicle.calculatedFields.secondaryColor',
                    registrationRenewalReminder: 'purchasedVehicle.registrationDetails.registrationRenewalReminder', // collected
                    // NOT SUPPORTING THIS FOR NOW
                    // vehicleStorageAddress:
                    // 	'purchasedVehicle.registrationDetails.vehicleStorageAddress', // collected (optional -- only if buyer wants to list a different storage address from reg address)
                },
                owner: {
                    consts: {
                        driverLicenseType: 'USDriversLicense', // for now fixed because we only support this value
                    },
                    issuingState: 'purchasedVehicle.calculatedFields.issuingState',
                    // driverLicenseType: 'purchasedVehicle.calculatedFields.driverLicenseType', // DL type
                    ssn: 'purchasedVehicle.registrationDetails.ssn',
                },
                lienholder1: {
                    consts: {
                        electronicLien: false,
                    },
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                },
            },
        },
    },
    [StateAbbreviation.UT]: {
        abbreviation: StateAbbreviation.UT,
        supportsRON: false,
        name: StateName.UT,
        insurance: {
            optional: false,
            insuranceName: 'Utah Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: null,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: true,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [
                'The insurance document must list the owner(s) insured, the full VIN of the vehicle purchased, effective date, and expiration date.',
            ],
            exemptVehicleTypes: [],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 65000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 15000,
                },
                {
                    code: VehicleCoverageCodes.PERSONAL_INJURY_PROTECTION,
                    name: VehicleCoverageFriendlyNames.PERSONAL_INJURY_PROTECTION,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 3000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
            documentProofNotes: 'Must show VIN, Effective Date, Expiration Date, and Owner Insured Name',
        },
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 105.5,
            estimatedTitlingFees: 6,
        },
        taxes: {
            salesTaxPercentage: 0.0745,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.YES,
        titlingAndRegistration: {
            stateReqs: {
                owner: {
                    idType: 'purchasedVehicle.calculatedFields.idType',
                    idNumber: 'purchasedVehicle.calculatedFields.idNumber',
                    issuingState: 'purchasedVehicle.calculatedFields.issuingState',
                },
                vehicle: {
                    consts: {
                        plateType: UT_PLATE_TYPE_ENUM.LIFE_ELEVATED_ARCHES,
                        regPeriodType: UT_REG_PERIOD_TYPE_ENUM.ONE_YEAR,
                    },
                },
                lienholder1: {
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
            },
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: UT_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: UT_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: UT_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.DIESEL]: UT_FUEL_TYPE_ENUM.DIESEL,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: UT_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: UT_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: UT_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: UT_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.TRUCK]: UT_VEHICLE_TYPE_ENUM.TRUCK,
                    [VehicleType.OHV]: UT_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.TRAILER]: UT_VEHICLE_TYPE_ENUM.TRAILER,
                    [VehicleType.VESSEL]: UT_VEHICLE_TYPE_ENUM.VESSEL,
                    [VehicleType.ATV]: UT_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: UT_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.LOW_SPEED]: UT_VEHICLE_TYPE_ENUM.PASSENGER,
                },
            },
        },
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE],
    },
    [StateAbbreviation.VT]: {
        abbreviation: StateAbbreviation.VT,
        supportsRON: false,
        name: StateName.VT,
        acceptableIdentityDocuments: [ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE],
        insurance: {
            optional: false,
            insuranceName: 'Vermont Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: null,
            maxDaysUntilEffective: null,
            proofRequired: false,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 10000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 100000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 10000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 58,
            estimatedTitlingFees: 42,
        },
        taxes: {
            salesTaxPercentage: 0.06,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    motoCubicCentimeters: 'oemVehicle.motoCubicCentimeters',
                    consts: {
                        regPeriodType: VT_REG_PERIOD_TYPE_ENUM.TWO_YEARS,
                    },
                },
                lienholder1: {
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
            },
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: VT_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: VT_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: VT_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.DIESEL]: VT_FUEL_TYPE_ENUM.DIESEL,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: VT_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: VT_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: VT_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: VT_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.TRUCK]: VT_VEHICLE_TYPE_ENUM.TRUCK,
                    [VehicleType.OHV]: VT_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.TRAILER]: VT_VEHICLE_TYPE_ENUM.TRAILER,
                    [VehicleType.VESSEL]: VT_VEHICLE_TYPE_ENUM.VESSEL,
                    [VehicleType.ATV]: VT_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: VT_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: VT_VEHICLE_TYPE_ENUM.PASSENGER,
                },
            },
        },
        requiresInStateLicense: false,
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
    },
    [StateAbbreviation.VA]: {
        abbreviation: StateAbbreviation.VA,
        supportsRON: false,
        name: StateName.VA,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        insurance: {
            optional: false,
            insuranceName: 'Virginia Liability Insurance',
            minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME],
            minDaysValid: null,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: true,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [VehicleType.MOPED],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 20000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.UNINSURED_AND_UNDERINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 20000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 47.5,
            estimatedTitlingFees: 15,
        },
        taxes: {
            salesTaxPercentage: 0.043,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        titlingAndRegistration: {
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: VA_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: VA_USE_TYPE_ENUM.FOR_HIRE,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: VA_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: VA_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: VA_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.PASSENGER]: VA_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOPED]: VA_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.OHV]: VA_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ATV]: VA_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: VA_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: VA_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                bodyType: {
                    [INTERNAL_BODY_TYPE_ENUM.MOTORCYCLE]: VA_BODY_TYPE_ENUM.MOTORCYCLE,
                    [INTERNAL_BODY_TYPE_ENUM.CABRIOLET]: VA_BODY_TYPE_ENUM.CABRIOLET,
                },
                bodyTypeId: {
                    [INTERNAL_BODY_TYPE_ENUM.MOTORCYCLE]: VA_BODY_TYPE_ID_ENUM.MOTORCYCLE,
                    [INTERNAL_BODY_TYPE_ENUM.CABRIOLET]: VA_BODY_TYPE_ID_ENUM.CABRIOLET,
                },
            },
            stateReqs: {
                vehicle: {
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident',
                    consts: {
                        numberOfAxles: 2,
                        feeExemption: false,
                        regPeriodType: VA_REG_PERIOD_TYPE_ENUM.TWO_YEARS,
                    },
                },
                registration: {
                    consts: {
                        requestedTitleType: REQUESTED_TITLE_TYPE_ENUM.ELECTRONIC_TITLE,
                    },
                },
                lienholder1: {
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                },
            },
        },
    },
    [StateAbbreviation.WA]: {
        abbreviation: StateAbbreviation.WA,
        supportsRON: false,
        name: StateName.WA,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        insurance: {
            optional: false,
            insuranceName: 'Washington Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: null,
            maxDaysUntilEffective: 0,
            proofRequired: false,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: true,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 10000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 170.25,
            estimatedTitlingFees: 15,
        },
        taxes: {
            salesTaxPercentage: 0.065,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        titlingAndRegistration: {
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: WA_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: WA_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: WA_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: WA_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: WA_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.PASSENGER]: WA_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOPED]: WA_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.OHV]: WA_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ATV]: WA_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.ORV]: WA_VEHICLE_TYPE_ENUM.OHV,
                    [VehicleType.LOW_SPEED]: WA_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: WA_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: WA_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: WA_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: WA_COLOR_ENUM.DARKBLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: WA_COLOR_ENUM.LIGHTBLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: WA_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: WA_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: WA_COLOR_ENUM.CHROMESTEEL,
                    [INTERNAL_COLOR_ENUM.COPPER]: WA_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: WA_COLOR_ENUM.CREAMIVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: WA_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: WA_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: WA_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: WA_COLOR_ENUM.DARKGREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: WA_COLOR_ENUM.LIGHTGREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: WA_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: WA_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: WA_COLOR_ENUM.MAROONBURGUNDY,
                    [INTERNAL_COLOR_ENUM.ORANGE]: WA_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: WA_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: WA_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: WA_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: WA_COLOR_ENUM.SILVERALUMINUM,
                    [INTERNAL_COLOR_ENUM.TAN]: WA_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: WA_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: WA_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: WA_COLOR_ENUM.YELLOW,
                },
            },
            stateReqs: {
                vehicle: {
                    consts: {
                        filingType: WA_FILING_TYPE_ENUM.TitleWithRegistration,
                        feeExemption: false,
                        serviceContracts: 0,
                        numberOfPlates: 1,
                        regServiceType: WA_REG_SERVICE_TYPE_ENUM.TitleWithRegistration,
                        isVehicleBeingShippedToOwner: true,
                    },
                    primaryColor: 'oemVehicle.calculatedFields.primaryColor',
                    secondaryColor: 'oemVehicle.calculatedFields.secondaryColor',
                    manufacturesSuggestedRetailPrice: 'purchasedVehicle.basePrice',
                    deliveryDate: 'purchasedVehicle.calculatedFields.deliveryDate',
                    isOwnerSpouseOfMilitary: 'purchasedVehicle.registrationDetails.isOwnerSpouseOfMilitary',
                    seatingCapacity: 'oemVehicle.seatingCapacity',
                    isOwnerResident: 'purchasedVehicle.registrationDetails.isOwnerResident', // only relevant when the owner is military
                },
                owner: {
                    licenseExpirationDate: 'purchasedVehicle.calculatedFields.licenseExpirationDate',
                    consts: {
                        applyingForPrimaryAddressException: false,
                    },
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                },
                military: {
                    stateStationed: 'purchasedVehicle.registrationDetails.stateStationed', // only relevant when the owner is military
                },
            },
        },
    },
    [StateAbbreviation.WV]: {
        abbreviation: StateAbbreviation.WV,
        supportsRON: false,
        name: StateName.WV,
        acceptableIdentityDocuments: [ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE],
        insurance: {
            optional: false,
            insuranceName: 'West Virginia Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: null,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: true,
            buyerMustBeNamedInsured: false,
            mustBeInState: true,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [],
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORIST_PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 25000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: true,
        fees: {
            estimatedRegistrationFees: 16,
            estimatedTitlingFees: 15,
        },
        taxes: {
            salesTaxPercentage: 0.06,
            variableFee: 15,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [VehicleType.NON_TITLED_VEHICLE],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        titlingAndRegistration: {
            stateReqs: {
                lienholder1: {
                    lienDate: 'purchasedVehicle.calculatedFields.lienDate',
                },
            },
            vituEnum: {
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: WV_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: WV_USE_TYPE_ENUM.COMMERCIAL,
                },
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: WV_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.DIESEL]: WV_FUEL_TYPE_ENUM.DIESEL,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: WV_FUEL_TYPE_ENUM.BATTERY_ELECTRIC_VEHICLE,
                },
                vehicleType: {
                    [VehicleType.PASSENGER]: WV_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.MOTORCYCLE]: WV_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: WV_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.TRUCK]: WV_VEHICLE_TYPE_ENUM.TRUCK,
                    [VehicleType.OHV]: WV_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.TRAILER]: WV_VEHICLE_TYPE_ENUM.TRAILER,
                    [VehicleType.VESSEL]: WV_VEHICLE_TYPE_ENUM.VESSEL,
                    [VehicleType.ATV]: WV_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: WV_VEHICLE_TYPE_ENUM.UTV,
                    [VehicleType.LOW_SPEED]: WV_VEHICLE_TYPE_ENUM.PASSENGER,
                },
            },
        },
        requiresInStateLicense: false,
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
    },
    [StateAbbreviation.WI]: {
        abbreviation: StateAbbreviation.WI,
        supportsRON: false,
        name: StateName.WI,
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
            ID_DOCUMENT_TYPE_ENUM.PASSPORT,
        ],
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 43.46,
            estimatedTitlingFees: 164.5,
        },
        taxes: {
            salesTaxPercentage: 0.05,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL, INTERNAL_USE_TYPE_ENUM.COMMERCIAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        insurance: {
            optional: false,
            insuranceName: 'Wisconsin Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: 0,
            maxDaysUntilEffective: 0,
            proofRequired: false,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: [],
            exemptVehicleTypes: [],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 10000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.UNINSURED_MOTORISTS,
                    name: VehicleCoverageFriendlyNames.UNINSURED_MOTORISTS,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        titlingAndRegistration: {
            stateReqs: {
                owner: {
                    ssn: 'purchasedVehicle.registrationDetails.ssn',
                },
                vehicle: {
                    consts: {
                        serviceContracts: 0,
                        isOwnerVeteran: false,
                        isOwnerStudentMilitary: false,
                    },
                    registrationDate: 'purchasedVehicle.calculatedFields.registrationDate', // VITU says this is not actually required but API fails without it
                },
                lienholder1: {
                    lienholderId: 'purchasedVehicle.calculatedFields.lienholderId',
                },
            },
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: WI_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: WI_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: WI_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.MOPED]: WI_VEHICLE_TYPE_ENUM.MOPED,
                    [VehicleType.PASSENGER]: WI_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.ATV]: WI_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: WI_VEHICLE_TYPE_ENUM.UTV,
                    [VehicleType.LOW_SPEED]: WI_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                color: {
                    [INTERNAL_COLOR_ENUM.BEIGE]: WI_COLOR_ENUM.BEIGE,
                    [INTERNAL_COLOR_ENUM.BLACK]: WI_COLOR_ENUM.BLACK,
                    [INTERNAL_COLOR_ENUM.BLUE]: WI_COLOR_ENUM.BLUE,
                    [INTERNAL_COLOR_ENUM.DARKBLUE]: WI_COLOR_ENUM.DARKBLUE,
                    [INTERNAL_COLOR_ENUM.LIGHTBLUE]: WI_COLOR_ENUM.LIGHTBLUE,
                    [INTERNAL_COLOR_ENUM.BROWN]: WI_COLOR_ENUM.BROWN,
                    [INTERNAL_COLOR_ENUM.BRONZE]: WI_COLOR_ENUM.BRONZE,
                    [INTERNAL_COLOR_ENUM.CHROMESTEEL]: WI_COLOR_ENUM.CHROMESTEEL,
                    [INTERNAL_COLOR_ENUM.COPPER]: WI_COLOR_ENUM.COPPER,
                    [INTERNAL_COLOR_ENUM.CREAMIVORY]: WI_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.GOLD]: WI_COLOR_ENUM.GOLD,
                    [INTERNAL_COLOR_ENUM.GRAY]: WI_COLOR_ENUM.GRAY,
                    [INTERNAL_COLOR_ENUM.GREEN]: WI_COLOR_ENUM.GREEN,
                    [INTERNAL_COLOR_ENUM.DARKGREEN]: WI_COLOR_ENUM.DARKGREEN,
                    [INTERNAL_COLOR_ENUM.LIGHTGREEN]: WI_COLOR_ENUM.LIGHTGREEN,
                    [INTERNAL_COLOR_ENUM.IVORY]: WI_COLOR_ENUM.IVORY,
                    [INTERNAL_COLOR_ENUM.LAVENDER]: WI_COLOR_ENUM.LAVENDER,
                    [INTERNAL_COLOR_ENUM.MAROONBURGUNDY]: WI_COLOR_ENUM.MAROONBURGUNDY,
                    [INTERNAL_COLOR_ENUM.ORANGE]: WI_COLOR_ENUM.ORANGE,
                    [INTERNAL_COLOR_ENUM.PINK]: WI_COLOR_ENUM.PINK,
                    [INTERNAL_COLOR_ENUM.PURPLE]: WI_COLOR_ENUM.PURPLE,
                    [INTERNAL_COLOR_ENUM.RED]: WI_COLOR_ENUM.RED,
                    [INTERNAL_COLOR_ENUM.SILVERALUMINUM]: WI_COLOR_ENUM.SILVERALUMINUM,
                    [INTERNAL_COLOR_ENUM.TAN]: WI_COLOR_ENUM.TAN,
                    [INTERNAL_COLOR_ENUM.TURQUOISE]: WI_COLOR_ENUM.TURQUOISE,
                    [INTERNAL_COLOR_ENUM.WHITE]: WI_COLOR_ENUM.WHITE,
                    [INTERNAL_COLOR_ENUM.YELLOW]: WI_COLOR_ENUM.YELLOW,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: WI_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: WI_USE_TYPE_ENUM.COMMERCIAL,
                },
            },
        },
    },
    [StateAbbreviation.WY]: {
        abbreviation: StateAbbreviation.WY,
        supportsRON: false,
        name: StateName.WY,
        inspectionRequired: INSPECTION_TYPE_ENUM.NONE,
        requiresInStateLicense: false,
        acceptableIdentityDocuments: [
            ID_DOCUMENT_TYPE_ENUM.ID_CARD,
            ID_DOCUMENT_TYPE_ENUM.DRIVERS_LICENSE,
        ],
        insurance: {
            optional: false,
            insuranceName: 'Wyoming Liability Insurance',
            minFieldsToCollect: [],
            minDaysValid: null,
            maxDaysUntilEffective: null,
            proofRequired: true,
            certificateRequired: false,
            buyerMustBeNamedInsured: false,
            mustBeInState: false,
            mustBeInStateForMilitary: false,
            miscellaneous: ['Out-of-state insurance must include a declaration page'],
            exemptVehicleTypes: [],
            // Rowan completed the below already using  https://www.nerdwallet.com/article/insurance/minimum-car-insurance-requirements.
            // These may be incorrect (since they're for cars), PLEASE DOUBLE CHECK AGAINST VITU REQUIREMENTS
            minimumLevels: [
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_PERSON_LIMIT,
                    amount: 25000,
                },
                {
                    code: VehicleCoverageCodes.BODILY_INJURY_LIABILITY,
                    name: VehicleCoverageFriendlyNames.BODILY_INJURY_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 50000,
                },
                {
                    code: VehicleCoverageCodes.PROPERTY_DAMAGE_LIABILITY,
                    name: VehicleCoverageFriendlyNames.PROPERTY_DAMAGE_LIABILITY,
                    type: insuranceMinimumLevelTypesEnum.PER_INCIDENT_OR_MULTIPLE_PEOPLE_LIMIT,
                    amount: 20000,
                },
            ],
            acceptableDocumentProof: [
                INSURANCE_DOCUMENT_TYPE_ENUM.CERTIFICATE_OF_INSURANCE,
                INSURANCE_DOCUMENT_TYPE_ENUM.DECLARATIONS_PAGE,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_BINDER,
                INSURANCE_DOCUMENT_TYPE_ENUM.INSURANCE_CARD,
                INSURANCE_DOCUMENT_TYPE_ENUM.VERIFICATION_OF_INSURANCE,
            ],
        },
        supportsTitleOnly: false,
        fees: {
            estimatedRegistrationFees: 295,
            estimatedTitlingFees: 15,
        },
        taxes: {
            salesTaxPercentage: 0.04,
            variableFee: 0,
        },
        tarProcesses: {
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTARSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOPED,
                    VehicleType.MOTORCYCLE,
                    VehicleType.DUAL_SPORT,
                    VehicleType.LOW_SPEED,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.GASOLINE, INTERNAL_FUEL_TYPE_ENUM.ELECTRIC],
                insurance: { minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME] },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTARNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [MIN_FIELDS_TO_COLLECT.CARRIER_NAME], // adding this so that we're able to find the NAIC number to provide the temp tag
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.automatedTitlingSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.assistedTitlingNotSupported]: {
                vehicleTypes: [
                    VehicleType.PASSENGER,
                    VehicleType.MOTORCYCLE,
                    VehicleType.TRUCK,
                    VehicleType.COMMERCIAL,
                    VehicleType.TRAILER,
                    VehicleType.MOPED,
                    VehicleType.VESSEL,
                    VehicleType.LOW_SPEED,
                    VehicleType.MOTORSCOOTER,
                    VehicleType.DUAL_SPORT,
                    VehicleType.ATV,
                    VehicleType.ORV,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.OHV,
                ],
                useTypes: [],
                fuelTypes: [],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
            [STATE_DATA_TAR_PROCESS_KEYS.noneSupported]: {
                vehicleTypes: [
                    VehicleType.OHV,
                    VehicleType.DUAL_SPORT,
                    VehicleType.NON_TITLED_VEHICLE,
                    VehicleType.ATV,
                    VehicleType.ORV,
                ],
                useTypes: [INTERNAL_USE_TYPE_ENUM.PERSONAL],
                fuelTypes: [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC, INTERNAL_FUEL_TYPE_ENUM.GASOLINE],
                insurance: {
                    optional: true,
                    proofRequired: false,
                    certificateRequired: false,
                    minFieldsToCollect: [],
                },
            },
        },
        titlingAndRegistration: {
            stateReqs: {
                vehicle: {
                    manufacturesSuggestedRetailPrice: 'purchasedVehicle.basePrice',
                },
            },
            vituEnum: {
                fuelType: {
                    [INTERNAL_FUEL_TYPE_ENUM.GASOLINE]: WY_FUEL_TYPE_ENUM.GAS,
                    [INTERNAL_FUEL_TYPE_ENUM.ELECTRIC]: WY_FUEL_TYPE_ENUM.ELECTRIC,
                },
                vehicleType: {
                    [VehicleType.MOTORCYCLE]: WY_VEHICLE_TYPE_ENUM.MOTORCYCLE,
                    [VehicleType.PASSENGER]: WY_VEHICLE_TYPE_ENUM.PASSENGER,
                    [VehicleType.ATV]: WY_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.ORV]: WY_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.OHV]: WY_VEHICLE_TYPE_ENUM.ATV,
                    [VehicleType.LOW_SPEED]: WY_VEHICLE_TYPE_ENUM.PASSENGER,
                },
                useType: {
                    [INTERNAL_USE_TYPE_ENUM.PERSONAL]: WY_USE_TYPE_ENUM.PERSONAL,
                    [INTERNAL_USE_TYPE_ENUM.COMMERCIAL]: WY_USE_TYPE_ENUM.COMMERCIAL,
                },
            },
        },
    },
};
const sellerStateDocsIndexed = [
    StateAbbreviation.FL,
    StateAbbreviation.NY,
    StateAbbreviation.NC,
    StateAbbreviation.CA,
    StateAbbreviation.DE,
    StateAbbreviation.NV,
    StateAbbreviation.UT,
    StateAbbreviation.LA,
    StateAbbreviation.SC,
    // StateAbbreviation.TN - in progress
    // StateAbbreviation.TX - in progress
    // ------------------------------
    // StateAbbreviation.AL,
    // StateAbbreviation.AK,
    // StateAbbreviation.AZ,
    // StateAbbreviation.AR,
    // StateAbbreviation.CO,
    // StateAbbreviation.CT,
    // StateAbbreviation.GA,
    // StateAbbreviation.HI,
    // StateAbbreviation.ID,
    // StateAbbreviation.IL,
    // StateAbbreviation.IN,
    // StateAbbreviation.IA,
    // StateAbbreviation.KS,
    // StateAbbreviation.KY,
    // StateAbbreviation.ME,
    // StateAbbreviation.MD,
    // StateAbbreviation.MA,
    // StateAbbreviation.MI,
    // StateAbbreviation.MN,
    // StateAbbreviation.MS,
    // StateAbbreviation.MO,
    // StateAbbreviation.MT,
    // StateAbbreviation.NE,
    // StateAbbreviation.NH,
    // StateAbbreviation.NJ,
    // StateAbbreviation.NM,
    // StateAbbreviation.NY,
    // StateAbbreviation.ND,
    // StateAbbreviation.OH,
    // StateAbbreviation.OK,
    // StateAbbreviation.OR,
    // StateAbbreviation.PA,
    // StateAbbreviation.RI,
    // StateAbbreviation.SD,
    // StateAbbreviation.VA,
    // StateAbbreviation.WA,
    // StateAbbreviation.WV,
    // StateAbbreviation.WI,
    // StateAbbreviation.WY,
];
// Implementing logic from VITU National API Taxable Selling Price Guide
function getTaxableSellingPrice(state, data) {
    switch (state) {
        case 'FL': {
            if ((!data.totalPrice && data.totalPrice !== 0) ||
                (!data.dealerFee && data.dealerFee !== 0) ||
                (!data.deliveryFee && data.deliveryFee !== 0)) {
                throw new Error('Missing required data for FL taxable selling price calculation. Needs totalPrice, dealerFee, and deliveryFee');
            }
            return data.totalPrice + data.dealershipFee + data.deliveryFee;
        }
        default:
            throw new Error(`Taxable selling price not implemented for state ${state}`);
    }
}

export { STATE_DATA, getTaxableSellingPrice, sellerStateDocsIndexed };
//# sourceMappingURL=stateData.js.map
